import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["child"],
  _excluded2 = ["child"];
import Immutable from 'immutable';
import { isEmpty, omit } from 'underscore';
// @ts-ignore not typed
import { importTreeFromLayoutDataApi } from 'layout-data-lib/LayoutDataTree/serialize';
// @ts-ignore not typed
import { setAlignmentOnAllColumnsInRow } from 'layout-data-lib/alignment/helpers';
import { appendRowToCell, insertColumnAfter, insertColumnBefore, appendColumnToEmptyRow, insertRowAfter, insertRowBefore, prependRowToCell
// @ts-ignore not typed
} from 'layout-data-lib/CellAndRowsTree/insertHelpers';
import { BEFORE } from 'layout-dnd-utils/js/constants';
import { getInsertedModulesFromRichText } from 'structured-content-lib/utils/hubdb';
import { DefaultInstanceColumns } from 'structured-content-lib/constants/enums/DefaultInstanceColumns';
import { SET_INSTANCE_DATA_SUCCEEDED, ADD_MODULES_TO_RICH_TEXT_PROPERTY, UPDATE_CURRENT_INSTANCE_VALUE, DELETE_MODULES_IN_RICH_TEXT_PROPERTY } from 'structured-content-lib/redux/actions/ActionTypes';
import { MODULES_IN_RICHTEXT } from 'structured-content-lib/constants/moduleInsertion';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { modifyColumnWidths, prepareNewModuleDataHelper
// @ts-ignore not typed
} from 'ContentEditorUI/utils/layoutSectionTreeUtils';
// @ts-ignore not typed
import CustomCellTweakingAutoDeleteLogicPerTestFlag from 'ContentEditorUI/data/tree/CustomCellTweakingAutoDeleteLogicPerTestFlag';
import * as actionTypes from 'ContentEditorUI/redux/actions/actionTypes';
import { BODY_ID } from 'ContentEditorUI/lib/widgetEdit/constants';
import { addModuleToFlexColumnHelper, copyLayoutSectionFromSchemaToContentIfNeeded, copyLayoutSectionFromSchemaToContent, findTreeWithCellName, getKeyForNonLayoutSection, getLayoutSectionTreeToModify, incrementModuleEditVersion, maybeParseFlexAreaTree, mergeModuleBodyHelper, mergeGridModuleBodyHelper, mergeModuleDataHelper, mergeLayoutFragmentDataHelper, updateGridNodeLabelHelper, normalizeFlexColumnData, removeCellFromLayoutSection, removeModule, removeRowFromLayoutSection, updateLayoutSectionTreeAndWidgets, updateMetaDataForModule, getIsModuleReducerDiffingEnabled, setInsertedModulesFromRichTextImmutable, getIndexedModuleInstances, deleteInsertedModulesFromRichTextImmutable
// @ts-ignore not typed
} from 'ContentEditorUI/utils/moduleReducerUtils';
// @ts-ignore not typed
import { isEmailBodyName } from 'ContentEditorUI/data/moduleUtils';
// @ts-ignore not typed
import { hasTestFlag } from 'ContentEditorUI/lib/testFlags';
import { DND_DO_NOT_WRAP_SINGLE_MODULE_IN_SECTION_FLAG } from 'ContentEditorUI/redux/selectors/testFlagSelectors';
// @ts-ignore not typed
import themePageOverridesReducer from 'ContentEditorUI/redux/reducers/themePageOverridesReducer';
import { captureMessage } from 'ContentEditorUI/lib/exceptions';
import { Map as ImmutableMap } from 'immutable';
import { DND_AREA_ID } from 'ContentEditorUI/utils/email/contentTreeUtils';
// @ts-ignore not typed
import { calculateDiff } from 'ContentEditorUI/utils/diffTools';
// @ts-ignore not typed
import { compareTrees } from 'layout-data-lib/LayoutDataTree/helpers';
import { original, produce } from 'immer';
import has from 'hs-lodash/has';
import get from 'hs-lodash/get';
import set from 'hs-lodash/set';
import unset from 'hs-lodash/unset';
import size from 'hs-lodash/size';
import mergeIn from '../../lib/mergeIn';
import { incrementModuleEditVersionImmer, updateMetaDataForModuleImmer, maybeParseFlexAreaTreeImmer, normalizeFlexColumnDataImmer, getKeyForNonLayoutSectionImmer, removeModuleImmer, addModuleToFlexColumnHelperImmer, removeCellFromLayoutSectionImmer, removeRowFromLayoutSectionImmer, getLayoutSectionTreeToModifyImmer, updateLayoutSectionTreeAndWidgetsImmer, mergeLayoutFragmentDataHelperImmer, updateGridNodeLabelHelperImmer, findTreeWithCellNameImmer, copyLayoutSectionFromSchemaToContentIfNeededImmer, mergeModuleDataHelperImmer, mergeModuleBodyHelperImmer, mergeGridModuleBodyHelperImmer, copyLayoutSectionFromSchemaToContentImmer, setImmerInsertedModulesFromRichText, deleteInsertedModulesFromRichTextImmer, logUnknownModuleToRaven } from '../../utils/moduleReducerImmerUtils';
import Raven from 'raven-js';
import { maybeToJS } from '../../utils/dataHelpers';
import GridLayoutDataTree from 'layout-data-lib/GridLayoutDataTree/GridLayoutDataTree';
import { getContainerBreakpointLayout, convertStackToGridLayout, computeWrappingStackTypeFromParentNode } from 'layout-data-lib/GridLayoutDataTree/utils';
import { createGridContainer } from 'layout-data-lib/GridLayoutDataTree/layoutBuilderUtils';
import { BUILDING_BLOCK_TYPES, GRID_NODE_TYPES } from 'layout-data-lib/GridLayoutDataTree/constants';
import { generateUniqueId } from 'layout-data-lib/GridLayoutDataTree/utils';
import { GridContainerLayoutTypename, StackContainerLayoutTypename } from '../../../__generated__/chirp/com/hubspot/content/grid/layouts/rpc/GridLayoutsRpc';
import { convertJsonToFieldValueAvroWithoutTypename, isStackContainerLayout, isContainer } from 'layout-data-lib/GridLayoutDataTree/typenameUtils';
import { copyClonedModulesToGridLayoutModules, copyClonedModulesToGridLayoutModulesImmer, createAddToGeneratedIdQueue, createGeneratedIdQueueForGridLayoutTree, createReadFromGeneratedIdQueue, getGridLayoutTreeToModify, getGridLayoutTreeToModifyImmer, getHydrateMissingPropertiesInGridLayoutTree, initializeGridLayoutModules, prepareNewGridModuleDataHelper } from '../../utils/gridModuleReducerUtils';
import { ContainerTypename } from '../../../__generated__/chirp/com/hubspot/content/grid/layouts/rpc/GridLayoutBuffersRpc';
import { ManualPositionTypename } from '../../../__generated__/chirp/com/hubspot/content/ai/editor/rpc/LayoutGeneration';
import { isEmptyObject } from '../../lib/collectionHelpers';
const NODE_NAME_QUEUES = {};
function createNodeNameQueueForTree(contentOrSchema, treeName) {
  set(NODE_NAME_QUEUES, [contentOrSchema, treeName], {
    cell: [],
    row: []
  });
}
function createAddToQueue(contentOrSchema, treeName) {
  return (type, val) => {
    if (!getIsModuleReducerDiffingEnabled()) {
      return;
    }
    const treeNames = get(NODE_NAME_QUEUES, [contentOrSchema, treeName, type], []);
    treeNames.push(val);
    set(NODE_NAME_QUEUES, [contentOrSchema, treeName, type], treeNames);
  };
}
export function createReadFromQueue(contentOrSchema, treeName) {
  return type => {
    if (!getIsModuleReducerDiffingEnabled()) {
      Raven.captureMessage('Trying to add to node name queue without enabling module reducer diffing.');
      console.error('Trying to add to node name queue without enabling module reducer diffing. Make sure to call enableModuleReducerDiffing before the module reducer is called');
    }
    const list = get(NODE_NAME_QUEUES, [contentOrSchema, treeName, type], []);
    return list.shift();
  };
}
let oldImmutableLayoutSectionTrees;
let oldImmerLayoutSectionTrees;
let oldImmutableFlexAreaTrees;
let oldImmerFlexAreaTrees;
const IMMER_TREE_REF_MISMATCH = 'IMMER_TREE_REF_MISMATCH';
const IMMUTABLE_TREE_REF_MISMATCH = 'IMMUTABLE_TREE_REF_MISMATCH';
const TREE_NAME_MISMATCH = 'TREE_NAME_MISMATCH';
const TREE_DIFF = 'TREE_DIFF';
function compareReduxTrees(currentImmutableTrees, currentImmerTrees, oldImmutableTrees, oldImmerTrees) {
  const immutableTreeNames = Object.keys(currentImmutableTrees);
  const immerTreeNames = Object.keys(currentImmerTrees);
  const treeNamesMatch = immutableTreeNames.length === immerTreeNames.length && immutableTreeNames.every(treeName => immerTreeNames.includes(treeName));
  if (!treeNamesMatch) {
    Raven.captureBreadcrumb({
      message: 'Tree name mismatch',
      level: 'error'
    });
    return {
      result: 'ERR',
      type: TREE_NAME_MISMATCH
    };
  }
  const treeNameWithDiff = immutableTreeNames.find(treeName => {
    const immerTree = currentImmerTrees[treeName];
    const immutableTree = currentImmutableTrees[treeName];
    if (oldImmerTrees && oldImmutableTrees) {
      if (oldImmerTrees[treeName] === immerTree && oldImmutableTrees[treeName] !== immutableTree || oldImmerTrees[treeName] !== immerTree && oldImmutableTrees[treeName] === immutableTree) {
        return true;
      } else if (oldImmerTrees[treeName] === immerTree && oldImmutableTrees[treeName] === immutableTree) {
        return false;
      }
    }
    const diffResult = compareTrees(immutableTree, immerTree, calculateDiff);
    return diffResult && Object.keys(diffResult).length > 0;
  });
  if (oldImmerTrees && oldImmutableTrees && treeNameWithDiff) {
    if (oldImmerTrees[treeNameWithDiff] === currentImmerTrees[treeNameWithDiff] && oldImmutableTrees[treeNameWithDiff] !== currentImmutableTrees[treeNameWithDiff]) {
      Raven.captureBreadcrumb({
        message: `Immutable tree ref mismatch for ${treeNameWithDiff}`,
        level: 'error'
      });
      return {
        result: 'ERR',
        type: IMMUTABLE_TREE_REF_MISMATCH,
        treeName: treeNameWithDiff
      };
    }
    if (oldImmerTrees[treeNameWithDiff] !== currentImmerTrees[treeNameWithDiff] && oldImmutableTrees[treeNameWithDiff] === currentImmutableTrees[treeNameWithDiff]) {
      Raven.captureBreadcrumb({
        message: `Immer tree ref mismatch for ${treeNameWithDiff}`,
        level: 'error'
      });
      return {
        result: 'ERR',
        type: IMMER_TREE_REF_MISMATCH,
        treeName: treeNameWithDiff
      };
    }
  }
  if (treeNameWithDiff) {
    const treeDiff = compareTrees(currentImmutableTrees[treeNameWithDiff], currentImmerTrees[treeNameWithDiff], calculateDiff);
    Raven.captureBreadcrumb({
      message: `Tree diff for ${treeNameWithDiff}`,
      level: 'error'
    });
    return {
      result: 'ERR',
      type: TREE_DIFF,
      treeDiff
    };
  }
  return {
    result: 'OK'
  };
}
export function compareModuleReducerSlices(immutableStateAsJsObject, immerState) {
  const baseDiff = calculateDiff(omit(immutableStateAsJsObject, ['layoutSectionTrees', 'schemaLayoutSectionTrees', 'gridLayoutTrees', 'schemaGridLayoutTrees', 'flexAreaTree']), omit(immerState, ['layoutSectionTrees', 'schemaLayoutSectionTrees', 'gridLayoutTrees', 'schemaGridLayoutTrees', 'flexAreaTree']), '', {
    shouldSerializeSetsAndMaps: true
  });
  if (!isEmpty(baseDiff)) {
    return baseDiff;
  }
  const immutableLayoutSectionTrees = immutableStateAsJsObject.layoutSectionTrees;
  const immerLayoutSectionTrees = immerState.layoutSectionTrees;
  const layoutSectionTreeResult = compareReduxTrees(immutableLayoutSectionTrees, immerLayoutSectionTrees, oldImmutableLayoutSectionTrees, oldImmerLayoutSectionTrees);
  oldImmutableLayoutSectionTrees = immutableLayoutSectionTrees;
  oldImmerLayoutSectionTrees = immerLayoutSectionTrees;
  if (layoutSectionTreeResult.result === 'ERR') {
    if (layoutSectionTreeResult.type === TREE_NAME_MISMATCH) {
      return {
        prev: {
          layoutSectionTrees: Object.keys(immutableLayoutSectionTrees)
        },
        next: {
          layoutSectionTrees: Object.keys(immerLayoutSectionTrees)
        }
      };
    } else if (layoutSectionTreeResult.type === TREE_DIFF) {
      return {
        layoutSectionTrees: layoutSectionTreeResult.treeDiff
      };
    } else {
      const treeNameWithDiff = layoutSectionTreeResult.treeName;
      return {
        prev: {
          layoutSectionTrees: treeNameWithDiff
        },
        next: {
          layoutSectionTrees: treeNameWithDiff
        }
      };
    }
  }
  const immutableFlexAreaTrees = immutableStateAsJsObject.flexAreaTree;
  const immerFlexAreaTrees = immerState.flexAreaTree;
  const flexAreaTreeResult = compareReduxTrees(immutableFlexAreaTrees, immerFlexAreaTrees, oldImmutableFlexAreaTrees, oldImmerFlexAreaTrees);
  oldImmutableFlexAreaTrees = immutableFlexAreaTrees;
  oldImmerFlexAreaTrees = immerFlexAreaTrees;
  if (flexAreaTreeResult.result === 'ERR') {
    if (flexAreaTreeResult.type === TREE_NAME_MISMATCH) {
      return {
        prev: {
          flexAreaTrees: Object.keys(immutableFlexAreaTrees)
        },
        next: {
          flexAreaTrees: Object.keys(immerFlexAreaTrees)
        }
      };
    } else if (flexAreaTreeResult.type === TREE_DIFF) {
      return {
        flexAreaTrees: flexAreaTreeResult.treeDiff
      };
    } else {
      const treeNameWithDiff = flexAreaTreeResult.treeName;
      return {
        prev: {
          flexAreaTrees: treeNameWithDiff
        },
        next: {
          flexAreaTrees: treeNameWithDiff
        }
      };
    }
  }
  return {};
}
export const moduleReducerInitialStateAsJSObject = {
  uneditableWidgets: {},
  schemaLayoutSectionTrees: {},
  // Suffix-ing with `tree` just to break previous references for now
  layoutSectionTrees: {},
  // Suffix-ing with `tree` just to break previous references for now
  layoutSectionWidgets: {},
  schemaGridLayoutTrees: {},
  gridLayoutTrees: {},
  gridLayoutModules: {},
  flexAreaTree: {},
  flexAreaSections: [],
  flexAreaStyles: {},
  flexAreaStyleSettings: {},
  flexAreasMetadata: {},
  userModuleDefaults: {},
  schemaWidgetContainers: {},
  widgetContainers: {},
  schemaWidgets: {},
  fakeModules: {},
  fakeModuleCustomUpdates: {},
  widgets: {},
  widgetsInRichText: {},
  contentCss: {},
  moduleMetaData: {},
  embedInfo: {},
  clonedModulesPendingDomOperations: new Set([]),
  mapOfClonedToOldStaticSectionName: {},
  themePageOverrides: null,
  //Used for universal theme settings to support undo/redo
  themeSettings: null
};
export const moduleReducerInitialState = Immutable.fromJS({
  uneditableWidgets: {},
  schemaLayoutSectionTrees: {},
  // Suffix-ing with `tree` just to break previous references for now
  layoutSectionTrees: {},
  // Suffix-ing with `tree` just to break previous references for now
  layoutSectionWidgets: {},
  schemaGridLayoutTrees: {},
  gridLayoutTrees: {},
  gridLayoutModules: {},
  flexAreaTree: {},
  flexAreaSections: [],
  flexAreaStyles: {},
  flexAreaStyleSettings: {},
  flexAreasMetadata: {},
  userModuleDefaults: {},
  schemaWidgetContainers: {},
  widgetContainers: {},
  schemaWidgets: {},
  fakeModules: {},
  fakeModuleCustomUpdates: {},
  widgets: {},
  widgetsInRichText: {},
  contentCss: {},
  moduleMetaData: {},
  embedInfo: {},
  // @ts-ignore will be migrated
  clonedModulesPendingDomOperations: new Immutable.Set(),
  // @ts-ignore will be migrated
  mapOfClonedToOldStaticSectionName: new Immutable.Map(),
  themePageOverrides: null,
  //Used for universal theme settings to support undo/redo
  themeSettings: null
});
const isNil = val => val === null || val === undefined;
export const moduleReducerAsJSObject = (state = moduleReducerInitialStateAsJSObject, action) => produce(state, draft => {
  const {
    type,
    payload
  } = action;

  // Check if any of the fake modules should update from this action
  if (has(draft, ['fakeModuleCustomUpdates', type])) {
    const {
      moduleName,
      updatePath
    } = get(draft, ['fakeModuleCustomUpdates', type]);
    const {
      metaData,
      isFakeUndoRedoProxiedUpdate
    } = action;

    // A fake undo redo proxied update is used by fakeUndoRedoUpdatesMiddleware. It should be ignored by this undoable module reducer
    // (but listened to by other non undoable reducers)
    if (!isFakeUndoRedoProxiedUpdate) {
      updateMetaDataForModuleImmer(draft, moduleName, metaData);
      incrementModuleEditVersionImmer({
        draft,
        id: moduleName
      });
      if (metaData.updatedRichTextModuleName) {
        incrementModuleEditVersionImmer({
          draft,
          id: metaData.updatedRichTextModuleName
        });
      }
      const fakeModuleUpdatePath = ['fakeModules', moduleName, 'body', ...updatePath];
      const newValue = updatePath.reduce((current, key) => !isNil(current[key]) ? current[key] : payload, payload);
      if (get(draft, fakeModuleUpdatePath) !== newValue) {
        set(draft, fakeModuleUpdatePath, newValue);
      }
    }
  }

  // Test Flag for https://git.hubteam.com/HubSpot/ContentEditorUI/issues/6194 (that triggers a few different behaviors)
  const doNotWrapSingleModuleInSection = hasTestFlag(DND_DO_NOT_WRAP_SINGLE_MODULE_IN_SECTION_FLAG);
  const shouldRemoveUnnecessaryWrappersForSingleColumnSection = doNotWrapSingleModuleInSection;
  draft.themePageOverrides = produce(draft.themePageOverrides, draftThemePageOverrides => themePageOverridesReducer(draftThemePageOverrides, action));
  switch (type) {
    case actionTypes.SET_FLEX_AREA_INDEX:
      {
        draft.flexAreasMetadata = {
          [DND_AREA_ID]: action.index
        };
        return draft;
      }
    case actionTypes.FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        const contentSchema = action.response;
        const {
          schema,
          content,
          isNewEmail,
          grid_layouts: gridLayouts
        } = contentSchema;
        const {
          default_grid_layouts: schemaGridLayouts,
          grid_layout_modules: schemaGridLayoutModules
        } = schema;
        const gridLayoutModules = !schemaGridLayoutModules || isEmptyObject(schemaGridLayoutModules) ? initializeGridLayoutModules(schemaGridLayouts) : schemaGridLayoutModules;
        const schemaLayoutSectionTrees = {};
        const layoutSectionTrees = {};
        const schemaGridLayoutTrees = {};
        const gridLayoutTrees = {};
        const uneditableWidgets = {};
        const allWidgetNamesInFlexColumns = new Set([]);
        let flexAreaTree = {};
        const embedInfo = schema.embed_info ? schema.embed_info : {};
        const {
          isCustomEmail
        } = action;
        const templateContainsFlexArea = Object.keys(schema.flex_areas).length > 0;
        const isNewEmailUsingCustomTemplateWithDndArea = isCustomEmail && templateContainsFlexArea && isNewEmail;
        if (isNewEmailUsingCustomTemplateWithDndArea) {
          UsageTracker.track('newDndInCustom');
        }
        flexAreaTree = maybeParseFlexAreaTreeImmer({
          content,
          templateContainsFlexArea
        });
        if (schema.widget_containers) {
          Object.keys(schema.widget_containers).forEach(containerName => {
            if (schema.widget_containers[containerName].widgets) {
              schema.widget_containers[containerName].widgets.forEach(widget => {
                allWidgetNamesInFlexColumns.add(widget.name);
              });
            }
          });
        }
        if (schema.layout_sections) {
          Object.keys(schema.layout_sections).forEach(lsId => {
            const nodeNameQueueReader = createReadFromQueue('schema', lsId);
            schemaLayoutSectionTrees[lsId] = importTreeFromLayoutDataApi(schema.layout_sections[lsId], {
              shouldPreventEmptyRows: false,
              CellClass: CustomCellTweakingAutoDeleteLogicPerTestFlag,
              nodeNameQueueReader
            });
          });
        }
        if (content.layoutSections) {
          Object.keys(content.layoutSections).forEach(lsId => {
            layoutSectionTrees[lsId] = importTreeFromLayoutDataApi(content.layoutSections[lsId], {
              shouldPreventEmptyRows: false,
              CellClass: CustomCellTweakingAutoDeleteLogicPerTestFlag,
              nodeNameQueueReader: createReadFromQueue('content', lsId)
            });
          });
        }
        if (gridLayouts) {
          Object.keys(gridLayouts).forEach(glId => {
            const generatedIdQueueReader = createReadFromGeneratedIdQueue('content', glId);
            gridLayoutTrees[glId] = GridLayoutDataTree.createTreeFromGridLayoutDataApi(gridLayouts[glId], {
              generatedIdQueueReader
            });
          });
        }

        // Omit order from values inside grid_layout_modules
        Object.values(gridLayoutModules || {}).forEach(moduleList => {
          moduleList.forEach(module => {
            delete module.order;
          });
        });

        // Build the schema grid layout trees
        if (schemaGridLayouts) {
          Object.keys(schemaGridLayouts).forEach(glId => {
            const generatedIdQueueReader = createReadFromGeneratedIdQueue('schema', glId);
            const options = {
              generatedIdQueueReader
            };
            if (gridLayoutModules) {
              options.transformNodeValueCallback = getHydrateMissingPropertiesInGridLayoutTree(gridLayoutModules, glId);
            }
            schemaGridLayoutTrees[glId] = GridLayoutDataTree.createTreeFromGridLayoutDataApi(schemaGridLayouts[glId], options);
          });
        }

        // Collect all non-overrideable modules (that are not in flex columns) to store those on uneditableWidgets
        if (schema.all_widgets) {
          schema.all_widgets.forEach(widget => {
            if ((widget.global_partial || !widget.overrideable) &&
            // TODO Branden can eventually remove this
            !allWidgetNamesInFlexColumns.has(widget.name) && !widget.layout_section_name) {
              uneditableWidgets[widget.name] = widget;
            }
          });
        }

        // Omit order from values inside layout_section_widgets
        Object.values(schema.layout_section_widgets || {}).forEach(moduleList => {
          moduleList.forEach(module => {
            delete module.order;
          });
        });

        // Filter out any `deleted_at` content widgets outside of containers (except for email bodies
        // to match https://git.hubteam.com/HubSpot/content4j/blob/2452d91c0c59af09e11112894796800c2c59a3e9/ContentModel/src/main/java/com/hubspot/content/model/Content.java#L439-L442 )
        const filteredContentWidgets = omit(content.widgets, widget => Boolean(widget.deleted_at) && !isEmailBodyName(widget.name));
        const widgetContainers = normalizeFlexColumnDataImmer(content.widgetContainers, schema.widget_containers);
        return Object.assign(draft, {
          uneditableWidgets,
          schemaLayoutSectionTrees,
          layoutSectionTrees,
          schemaGridLayoutTrees,
          gridLayoutTrees,
          gridLayoutModules,
          flexAreaTree,
          // NOTE, trying to removing this but still need for now
          layoutSectionWidgets: schema.layout_section_widgets || {},
          schemaWidgetContainers: schema.widget_containers,
          widgetContainers,
          schemaWidgets: omit(schema.widgets, ['preview_text']),
          // instead lives in previewTextReducer
          widgets: omit(filteredContentWidgets, ['preview_text']),
          contentCss: content.css || {},
          widgetsInRichText: schema.widgets_in_rich_text || {},
          embedInfo
        });
      }
    case actionTypes.FETCH_TEMPLATE_SCHEMA_SUCCEEDED:
      {
        const templateSchema = action.response;
        const {
          schema
        } = templateSchema;
        const schemaLayoutSectionTrees = {};
        const layoutSectionTrees = {};
        const uneditableWidgets = {};
        const orderlessLayoutSectionWidgets = {};

        // Filter out any `deleted_at` content widgets outside of containers (except for email bodies
        // to match https://git.hubteam.com/HubSpot/content4j/blob/2452d91c0c59af09e11112894796800c2c59a3e9/ContentModel/src/main/java/com/hubspot/content/model/Content.java#L439-L442 )
        const filteredContentWidgets = omit(schema.all_widgets, widget => Boolean(widget.deleted_at) && !isEmailBodyName(widget.name));

        // TODO: Fix this?
        // @ts-ignore not sure why this was here but we should fix it
        const widgetContainers = normalizeFlexColumnDataImmer([]);
        return Object.assign(draft, {
          uneditableWidgets,
          schemaLayoutSectionTrees,
          layoutSectionTrees,
          // NOTE, trying to removing this but still need for now
          layoutSectionWidgets: orderlessLayoutSectionWidgets,
          schemaWidgetContainers: schema.widget_containers || [],
          widgetContainers,
          schemaWidgets: omit(schema.all_widgets, ['preview_text']),
          // instead lives in previewTextReducer
          widgets: omit(filteredContentWidgets, ['preview_text']),
          contentCss: {}
        });
      }
    case SET_INSTANCE_DATA_SUCCEEDED:
      {
        if (payload.values && payload.values[DefaultInstanceColumns.hs_modules_in_richtext]) {
          const modulesInRichText = getInsertedModulesFromRichText(payload.values[DefaultInstanceColumns.hs_modules_in_richtext]);
          return setImmerInsertedModulesFromRichText(draft, modulesInRichText);
        }
        return draft;
      }
    case ADD_MODULES_TO_RICH_TEXT_PROPERTY:
      {
        const newModules = getIndexedModuleInstances(payload.newModuleInstances);
        return setImmerInsertedModulesFromRichText(draft, newModules);
      }
    case DELETE_MODULES_IN_RICH_TEXT_PROPERTY:
      {
        return deleteInsertedModulesFromRichTextImmer(draft, payload.removedModuleInstances);
      }
    case UPDATE_CURRENT_INSTANCE_VALUE:
      {
        // When a module in rich text is updated we need to update it in the module state
        if (payload.fieldKey === MODULES_IN_RICHTEXT) {
          const modulesInRichText = getInsertedModulesFromRichText(payload.newVal);
          return setImmerInsertedModulesFromRichText(draft, modulesInRichText);
        }
        return draft;
      }
    case actionTypes.MOVED_MODULE:
      {
        const {
          movingModuleId,
          newIndex,
          newColumnId
        } = payload;
        const key = getKeyForNonLayoutSectionImmer(draft, movingModuleId);
        if (!key) {
          logUnknownModuleToRaven(movingModuleId);
          return draft;
        }
        const module = get(draft, key);
        removeModuleImmer(draft, movingModuleId);
        addModuleToFlexColumnHelperImmer(draft, newColumnId, newIndex, module);
        return draft;
      }
    case actionTypes.ADDED_MODULE:
      {
        const {
          module,
          containerId,
          index
        } = payload;
        addModuleToFlexColumnHelperImmer(draft, containerId, index, module);
        return draft;
      }
    case actionTypes.DELETED_MODULE:
      {
        const {
          id
        } = payload;
        removeModuleImmer(draft, id);
        return draft;
      }
    case actionTypes.ADDED_MODULES_TO_POST_BODY:
      {
        const {
          modules
        } = payload;
        modules.forEach(module => {
          if (draft.widgetsInRichText.hasOwnProperty(module.name)) {
            throw new Error(`ERROR module ${module.name} exists in widgetsInRichText`);
          }
          draft.widgetsInRichText[module.name] = module;
        });
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_MODULE_DELETED:
      {
        const {
          layoutSectionId,
          moduleId
        } = payload;
        removeCellFromLayoutSectionImmer(draft, layoutSectionId, moduleId, {
          shouldRemoveUnnecessaryWrappersForSingleColumnSection
        });
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_COLUMN_DELETED:
      {
        const {
          layoutSectionId,
          columnId
        } = payload;
        removeCellFromLayoutSectionImmer(draft, layoutSectionId, columnId, {
          shouldRemoveUnnecessaryWrappersForSingleColumnSection
        });
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_ROW_DELETED:
      {
        const {
          layoutSectionId,
          rowId
        } = payload;
        removeRowFromLayoutSectionImmer(draft, layoutSectionId, rowId);
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_INSERTED_IN_EMPTY_ROW:
      {
        const {
          rowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModifyImmer(draft, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = appendColumnToEmptyRow(tree, rowId, {
          existingColumnId,
          newModuleSchemaJson,
          originTree
        });
        // Bail if this tree action was a no-op
        if (tree === newTree && originTree === newOriginTree) {
          return draft;
        }
        updateLayoutSectionTreeAndWidgetsImmer({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          draft
        });
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_COLUMN_INSERTED_AFTER:
      {
        const {
          columnId,
          existingRowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModifyImmer(draft, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = insertColumnAfter(tree, columnId, {
          existingColumnId,
          existingRowId,
          newModuleSchemaJson,
          originTree
        });
        // Bail if this tree action was a no-op
        if (tree === newTree && originTree === newOriginTree) {
          return draft;
        }
        updateLayoutSectionTreeAndWidgetsImmer({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          draft
        });
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_COLUMN_INSERTED_BEFORE:
      {
        const {
          columnId,
          existingRowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModifyImmer(draft, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = insertColumnBefore(tree, columnId, {
          existingColumnId,
          existingRowId,
          newModuleSchemaJson,
          originTree
        });
        // Bail if this tree action was a no-op
        if (tree === newTree && originTree === newOriginTree) {
          return draft;
        }
        updateLayoutSectionTreeAndWidgetsImmer({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          draft
        });
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_ROW_INSERTED_AFTER:
      {
        const {
          rowId,
          existingRowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          shouldWrapSingleModuleInSection = !doNotWrapSingleModuleInSection,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModifyImmer(draft, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = insertRowAfter(tree, rowId, {
          existingColumnId,
          existingRowId,
          newModuleSchemaJson,
          originTree,
          shouldWrapSingleModuleInSection
        });
        // Bail if this tree action was a no-op
        if (tree === newTree && originTree === newOriginTree) {
          return draft;
        }
        updateLayoutSectionTreeAndWidgetsImmer({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          draft
        });
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_ROW_INSERTED_BEFORE:
      {
        const {
          rowId,
          existingRowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          shouldWrapSingleModuleInSection = !doNotWrapSingleModuleInSection,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModifyImmer(draft, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = insertRowBefore(tree, rowId, {
          existingColumnId,
          existingRowId,
          newModuleSchemaJson,
          originTree,
          shouldWrapSingleModuleInSection
        });
        // Bail if this tree action was a no-op
        if (tree === newTree && originTree === newOriginTree) {
          return draft;
        }
        updateLayoutSectionTreeAndWidgetsImmer({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          draft
        });
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_ROW_CLONED_BELOW:
      {
        const {
          rowId,
          layoutSectionId
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const {
          tree: newTree,
          modifiedColumns,
          mapOfClonedToOldNodeName
        } = tree.cloneNewRowBelow(rowId);

        // Bail if this tree action was a no-op
        if (tree === newTree) {
          return draft;
        }
        updateLayoutSectionTreeAndWidgetsImmer({
          layoutSectionId,
          modifiedColumns,
          tree: newTree,
          draft,
          mapOfClonedToOldNodeName
        });
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_CELL_CLONED_TO_RIGHT:
      {
        const {
          cellId,
          layoutSectionId
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        let cellToClone = cellId;

        // If cloning a single module in a column, clone the parent column instead
        const cell = tree.findCell(cellId);
        if (cell.isOnlyModuleInWrapperColumn()) {
          cellToClone = cell.getParent().getParentName();
        }
        const {
          tree: newTree,
          modifiedColumns,
          mapOfClonedToOldNodeName
        } = tree.cloneNewCellToRight(cellToClone);

        // Bail if this tree action was a no-op
        if (tree === newTree) {
          return draft;
        }
        updateLayoutSectionTreeAndWidgetsImmer({
          layoutSectionId,
          modifiedColumns,
          tree: newTree,
          draft,
          mapOfClonedToOldNodeName
        });
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_INSERTED_IN_EMPTY_COLUMN:
    case actionTypes.LAYOUT_SECTION_ROW_APPENDED:
      {
        const {
          columnId,
          existingRowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          shouldWrapSingleModuleInSection = !doNotWrapSingleModuleInSection,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModifyImmer(draft, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = appendRowToCell(tree, columnId, {
          existingColumnId,
          existingRowId,
          newModuleSchemaJson,
          originTree,
          shouldWrapSingleModuleInSection
        });
        updateLayoutSectionTreeAndWidgetsImmer({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          draft
        });
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_ROW_PREPENDED:
      {
        const {
          columnId,
          existingRowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          shouldWrapSingleModuleInSection = !doNotWrapSingleModuleInSection,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModifyImmer(draft, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = prependRowToCell(tree, columnId, {
          existingColumnId,
          existingRowId,
          newModuleSchemaJson,
          originTree,
          shouldWrapSingleModuleInSection
        });
        // Bail if this tree action was a no-op
        if (tree === newTree && originTree === newOriginTree) {
          return draft;
        }
        updateLayoutSectionTreeAndWidgetsImmer({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          draft
        });
        return draft;
      }
    case actionTypes.MODULE_RESET_LAYOUT_STYLES:
    case actionTypes.LAYOUT_SECTION_CELL_RESET_LAYOUT_STYLES:
      {
        const {
          layoutSectionId,
          cellId
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const newTree = tree.mergeIntoCellValue(cellId, {
          styles: {}
        }).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.MOBILE_LAYOUT_SECTION_CELL_RESET_LAYOUT_STYLES:
      {
        const {
          layoutSectionId,
          cellId
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const newTree = tree.mergeIntoCellValue(cellId, {
          mobileMargin: {},
          mobilePadding: {}
        }, {
          path: ['styles']
        }).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.MODULE_SET_LAYOUT_STYLES:
    case actionTypes.LAYOUT_SECTION_CELL_SET_LAYOUT_STYLES:
      {
        const {
          layoutSectionId,
          cellId,
          newLayoutStyles
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const newTree = tree.mergeIntoCellStyles(cellId, newLayoutStyles).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_ROW_SET_LAYOUT_STYLES:
      {
        const {
          layoutSectionId,
          rowId,
          newLayoutStyles
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const newTree = tree.mergeIntoRowStyles(rowId, newLayoutStyles).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.SET_BREAKPOINT_STYLES_FOR_TREE_NODE:
      {
        const {
          layoutSectionId,
          nodeId,
          newLayoutStyles,
          breakpoint
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        let node;
        const isCell = tree.hasCell(nodeId);
        if (isCell) {
          node = tree.findCell(nodeId);
        } else {
          node = tree.findRow(nodeId);
        }
        if (node.isModule()) {
          incrementModuleEditVersionImmer({
            draft,
            id: nodeId
          });
        }
        const existingLayoutStyles = node.getLayoutStyleData() || {};
        const existingBreakpointStyles = existingLayoutStyles.breakpointStyles || {};

        // Create new object reference, copying refrences to all the existing styles set in that breakpoint
        const newStylesForThisBreakpoint = Object.assign({},
        // New object reference for this breakpoint
        existingBreakpointStyles[breakpoint],
        // Copy over references to all the existing styles objects
        newLayoutStyles // Override just the styles that changed
        );

        // Create new object reference, copying references to all the existing breakpoint objects
        const newBreakpointStyles = Object.assign({},
        // New object reference
        existingBreakpointStyles,
        // Copy over references to all the existing breakpoint objects
        {
          [breakpoint]: newStylesForThisBreakpoint // Override just the breakpoint we are modifying with the `newStylesForThisBreakpoint` object from above
        });
        let newTree;
        if (isCell) {
          newTree = tree.mergeIntoCellStyles(nodeId, {
            breakpointStyles: newBreakpointStyles
          }).tree;
        } else {
          newTree = tree.mergeIntoRowStyles(nodeId, {
            breakpointStyles: newBreakpointStyles
          }).tree;
        }
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_ROW_RESET_LAYOUT_STYLES:
      {
        const {
          layoutSectionId,
          rowId
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const newTree = tree.mergeIntoRowValue(rowId, {
          styles: {}
        }).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.MOBILE_LAYOUT_SECTION_ROW_RESET_LAYOUT_STYLES:
      {
        const {
          layoutSectionId,
          rowId
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const newTree = tree.mergeIntoRowValue(rowId, {
          mobileMargin: {},
          mobilePadding: {}
        }, {
          path: ['styles']
        }).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_ROW_SET_VERTICAL_ALIGNMENT:
      {
        const {
          layoutSectionId,
          rowId,
          verticalAlignment
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const newTree = setAlignmentOnAllColumnsInRow(tree, rowId, verticalAlignment).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_SET_CELL_CSS_ID:
      {
        const {
          layoutSectionId,
          cellId,
          cssId
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const newTree = tree.mergeIntoCellParams(cellId, {
          css_id: cssId
        }).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_SET_CELL_CSS_STYLES:
      {
        const {
          layoutSectionId,
          cellId,
          cssStyles
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const newTree = tree.mergeIntoCellParams(cellId, {
          css_style: cssStyles
        }).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_SET_CELL_CSS_CLASS:
      {
        const {
          layoutSectionId,
          cellId,
          cssClass
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const newClassString = cssClass;
        const newTree = tree.mergeIntoCellParams(cellId, {
          css_class: newClassString
        }).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_SET_ROW_CSS_CLASS:
      {
        const {
          layoutSectionId,
          rowId,
          cssClass
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const newClassString = cssClass;
        const newTree = tree.mergeIntoRowValue(rowId, {
          cssClass: newClassString
        }).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_ADD_CLASS_TO_CELL:
      {
        const {
          layoutSectionId,
          cellId,
          cssClass
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const currentParams = tree.findCell(cellId).getParams();
        const newClassString = `${currentParams.css_class} ${cssClass}`;
        const newTree = tree.mergeIntoCellParams(cellId, {
          css_class: newClassString
        }).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_REMOVE_CLASS_FROM_CELL:
      {
        const {
          layoutSectionId,
          cellId,
          cssClass
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const currentParams = tree.findCell(cellId).getParams();
        const classRegex = new RegExp(`(?:(\\s|^))${cssClass}(?:(\\s|$))`, 'g');
        const newClassString = currentParams.css_class.replace(classRegex, '');
        const newTree = tree.mergeIntoCellParams(cellId, {
          css_class: newClassString
        }).tree;
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_COLUMNS_RESIZED:
      {
        const {
          layoutSectionId,
          leftColumnInfo,
          rightColumnInfo
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        const newTree = modifyColumnWidths(tree, leftColumnInfo, rightColumnInfo);
        if (get(draft, ['layoutSectionTrees', layoutSectionId]) !== newTree) {
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_SET_LABEL:
      {
        const {
          id,
          partialBody,
          isRow
        } = payload;
        mergeLayoutFragmentDataHelperImmer(draft, id, partialBody, isRow);
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_SET_LABEL:
      {
        const {
          id,
          partialBody,
          gridLayoutId
        } = payload;
        updateGridNodeLabelHelperImmer(draft, id, partialBody, gridLayoutId);
        return draft;
      }
    case actionTypes.LAYOUT_SECTION_SET_LAYOUT_LOCKED:
      {
        const {
          layoutSectionId,
          isLayoutLocked
        } = payload;
        const tree = get(draft, ['layoutSectionTrees', layoutSectionId]);
        if (tree) {
          const {
            tree: newTree
          } = tree.modifyLayoutLockState(layoutSectionId, isLayoutLocked);
          set(draft, ['layoutSectionTrees', layoutSectionId], newTree);
        }
        return draft;
      }
    case actionTypes.SET_MODULE_BODY:
      {
        const {
          id,
          body
        } = payload;
        const tree = findTreeWithCellNameImmer(draft, id);
        incrementModuleEditVersionImmer({
          draft,
          id
        });
        if (tree) {
          copyLayoutSectionFromSchemaToContentIfNeededImmer(draft, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = get(draft, ['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(id);

          // CSS data from template is stored in the cell params, but with CMV1 templates
          // we compeltely replace the params of a cell with the new module body coming in.
          // This is special casing the css data to make sure it doesn't get blown away on the layout
          // tree cell when a module body is replaced.
          const existingCellParams = cell.getParams();
          const existingCellStyles = {
            css_id: existingCellParams.css_id,
            css_class: existingCellParams.css_class,
            css_style: existingCellParams.css_style
          };
          const newParamsToSet = Object.assign({}, existingCellStyles, body);
          ({
            tree: newTree
          } = newTree.modifyCellParams(cell.getName(), newParamsToSet));
          return set(draft, ['layoutSectionTrees', tree.getRootName()], newTree);
        }
        const keyBase = getKeyForNonLayoutSectionImmer(draft, id);
        if (!keyBase) {
          logUnknownModuleToRaven(id);
          return draft;
        }
        const key = [...keyBase, 'body'];
        return set(draft, key, body);
      }
    case actionTypes.SET_DEPRECATED_STYLES_FLAGS:
    case actionTypes.MERGE_MODULE_BODY:
      {
        const {
          id,
          partialBody,
          moduleDefaultType,
          metaData
        } = payload;
        updateMetaDataForModuleImmer(draft, id, metaData);
        incrementModuleEditVersionImmer({
          draft,
          id
        });
        mergeModuleBodyHelperImmer(draft, id, partialBody, {
          moduleDefaultType
        });
        return draft;
      }
    case actionTypes.MERGE_GRID_MODULE_BODY:
      {
        const {
          id,
          partialBody,
          metaData
        } = payload;
        updateMetaDataForModuleImmer(draft, id, metaData);
        incrementModuleEditVersionImmer({
          draft,
          id
        });
        mergeGridModuleBodyHelperImmer(draft, id, partialBody);
        return draft;
      }
    case actionTypes.MERGE_MODULE_DATA:
      {
        const {
          id,
          partialBody,
          metaData,
          layoutSectionId,
          gridLayoutId
        } = payload;
        updateMetaDataForModuleImmer(draft, id, metaData);
        incrementModuleEditVersionImmer({
          draft,
          id
        });
        if (gridLayoutId && partialBody.label) {
          updateGridNodeLabelHelperImmer(draft, id, partialBody, gridLayoutId, true);
        } else {
          mergeModuleDataHelperImmer(draft, id, partialBody, layoutSectionId);
        }
        return draft;
      }
    case actionTypes.MERGE_MODULE_META_DATA:
      {
        const {
          id,
          metaData,
          incrementEditVersion
        } = payload;
        updateMetaDataForModuleImmer(draft, id, metaData);
        if (incrementEditVersion) {
          incrementModuleEditVersionImmer({
            draft,
            id
          });
        }
        return draft;
      }
    case actionTypes.SET_MODULE_SMART_OBJECT_BODY:
      {
        const {
          id,
          smartObjectIndex,
          body,
          updateEditVersion
        } = payload;
        const tree = findTreeWithCellNameImmer(draft, id);
        if (updateEditVersion) {
          incrementModuleEditVersionImmer({
            draft,
            id
          });
        }
        if (tree) {
          copyLayoutSectionFromSchemaToContentIfNeededImmer(draft, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = get(draft, ['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(id);
          const smartObjectsFromTree = cell.getParams().smart_objects || [];
          const newParamPartial = {
            smart_objects: [...mergeIn(smartObjectsFromTree, [smartObjectIndex, 'body'], body)]
          };
          ({
            tree: newTree
          } = newTree.mergeIntoCellParams(cell.getName(), newParamPartial));
          return set(draft, ['layoutSectionTrees', tree.getRootName()], newTree);
        }
        const keyBase = getKeyForNonLayoutSectionImmer(draft, id);
        if (!keyBase) {
          logUnknownModuleToRaven(id);
          return draft;
        }
        const key = [...keyBase, 'smart_objects', smartObjectIndex, 'body'];
        return set(draft, key, body);
      }
    case actionTypes.MERGE_MODULE_SMART_OBJECT_BODY:
      {
        const {
          id,
          metaData,
          partialBody,
          smartObjectIndex,
          updateEditVersion
        } = payload;
        updateMetaDataForModuleImmer(draft, id, metaData);
        const tree = findTreeWithCellNameImmer(draft, id);
        if (updateEditVersion) {
          incrementModuleEditVersionImmer({
            draft,
            id
          });
        }
        if (tree) {
          copyLayoutSectionFromSchemaToContentIfNeededImmer(draft, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = get(draft, ['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(id);
          const smartObjectsFromTree = cell.getParams().smart_objects || [];
          const newParamPartial = {
            smart_objects: [...mergeIn(smartObjectsFromTree, [smartObjectIndex, 'body'], partialBody)]
          };
          ({
            tree: newTree
          } = newTree.mergeIntoCellParams(cell.getName(), newParamPartial));
          return set(draft, ['layoutSectionTrees', tree.getRootName()], newTree);
        }
        const keyBase = getKeyForNonLayoutSectionImmer(draft, id);
        if (!keyBase) {
          logUnknownModuleToRaven(id);
          return draft;
        }
        const key = [...keyBase, 'smart_objects', smartObjectIndex, 'body'];
        return mergeIn(draft, key, partialBody);
      }
    case actionTypes.SET_MODULE_STYLES:
      {
        const {
          id,
          styles
        } = payload;
        const tree = findTreeWithCellNameImmer(draft, id);
        if (tree) {
          copyLayoutSectionFromSchemaToContentIfNeededImmer(draft, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = get(draft, ['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(id);
          ({
            tree: newTree
          } = newTree.mergeIntoCellParams(cell.getName(), styles));
          return set(draft, ['layoutSectionTrees', tree.getRootName()], newTree);
        }
        let pathToKey;
        if (id === BODY_ID) {
          pathToKey = ['contentCss', BODY_ID];
        } else {
          const keyBase = getKeyForNonLayoutSectionImmer(draft, id);
          if (!keyBase) {
            logUnknownModuleToRaven(id);
            return draft;
          }
          pathToKey = [...keyBase, 'css'];
        }
        if (styles.css) {
          set(draft, pathToKey, styles.css);
        }
        if (styles.child_css) {
          set(draft, [...getKeyForNonLayoutSectionImmer(draft, id), 'child_css'], styles.child_css);
        }
        return draft;
      }
    case actionTypes.SET_MODULE_BREAKPOINT_STYLES:
      {
        const {
          id,
          styles,
          activeBreakpoint
        } = payload;
        incrementModuleEditVersionImmer({
          draft,
          id
        });
        const keyBase = getKeyForNonLayoutSectionImmer(draft, id);
        if (!keyBase) {
          logUnknownModuleToRaven(id);
          return draft;
        }
        const stylePath = [...keyBase, 'styles'];
        const breakpointPath = [...stylePath, 'breakpointStyles', activeBreakpoint];
        const existingBreakpointStyles = get(draft, breakpointPath, {});
        const newBreakpointStyles = Object.assign(existingBreakpointStyles, styles);
        set(draft, breakpointPath, newBreakpointStyles);
        return draft;
      }
    case actionTypes.REMOVE_FAKE_BODY_MODULE_STYLES:
      {
        unset(draft, ['contentCss', BODY_ID]);
        return draft;
      }
    case actionTypes.UPDATED_CONTAINERS_FROM_PREVIEW:
      {
        const {
          containers
        } = payload;
        const originalState = original(draft);
        const newLists = containers.map(container => {
          const {
            widgets
          } = container;
          return widgets.map((moduleId, order) => {
            var _getKeyForNonLayoutSe;
            const key = (_getKeyForNonLayoutSe = getKeyForNonLayoutSectionImmer(originalState, moduleId)) !== null && _getKeyForNonLayoutSe !== void 0 ? _getKeyForNonLayoutSe : ['widgetContainers', undefined, 'widgets', undefined];
            // @ts-ignore This is a known weird state. We should look to remove the fallback above
            const existingWidget = get(draft, key);
            existingWidget.order = order;
            return existingWidget;
          });
        });
        // TODO: Ehhh, messy. See if we can clean this up
        containers.forEach((container, index) => {
          const {
            id
          } = container;
          set(draft, ['widgetContainers', id, 'widgets'], newLists[index]);
        });
        return draft;
      }
    case actionTypes.UPDATED_MODULE_SMART_RULES:
      {
        const {
          id,
          smartObject: {
            body,
            definition_id,
            smart_type,
            smart_objects
          }
        } = payload;
        const tree = findTreeWithCellNameImmer(draft, id);
        const contentsToMerge = {
          smart_objects
        };
        if (smart_objects.length && (!definition_id || !smart_type)) {
          captureMessage('Trying to update smart objects with null definition_id or null smart_type in non-deletion action', {
            level: 'warning',
            extra: payload
          });
        } else {
          contentsToMerge.definition_id = definition_id;
          contentsToMerge.smart_type = smart_type;
        }
        if (tree) {
          copyLayoutSectionFromSchemaToContentIfNeededImmer(draft, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = get(draft, ['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(id);
          const paramsToMerge = body ? Object.assign({}, body, contentsToMerge) : contentsToMerge;
          ({
            tree: newTree
          } = newTree.mergeIntoCellParams(cell.getName(), paramsToMerge));
          return set(draft, ['layoutSectionTrees', tree.getRootName()], newTree);
        }
        const key = getKeyForNonLayoutSectionImmer(draft, id);
        if (!key) {
          logUnknownModuleToRaven(id);
          return draft;
        }
        if (body && size(body) > 0) {
          set(draft, [...key, 'body'], body);
        }
        return mergeIn(draft, key, contentsToMerge);
      }
    case actionTypes.REMOVED_MODULE_SMART_RULES:
      {
        const tree = findTreeWithCellNameImmer(draft, payload.id);
        if (tree) {
          copyLayoutSectionFromSchemaToContentIfNeededImmer(draft, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = get(draft, ['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(payload.id);
          const modifiedParams = cell.getParams();
          modifiedParams.definition_id = null;
          modifiedParams.smart_type = null;
          modifiedParams.smart_objects = [];
          ({
            tree: newTree
          } = newTree.modifyCellParams(cell.getName(), modifiedParams));
          return set(draft, ['layoutSectionTrees', tree.getRootName()], newTree);
        }

        // return set(
        //   set(
        //     set(draft, [...key, 'definition_id'], null),
        //     [...key, 'smart_type'],
        //     null
        //   ),
        //   [...key, 'smart_objects'],
        //   []
        // );
        const key = getKeyForNonLayoutSectionImmer(draft, payload.id);
        if (!key) {
          logUnknownModuleToRaven(payload.id);
          return draft;
        }
        const val = get(draft, key);
        if (!val) {
          return draft;
        }
        val.definition_id = null;
        val.smart_type = null;
        val.smart_objects = [];
        // set(draft, [...key, 'definition_id'], null);
        // set(draft, [...key, 'smart_type'], null);
        // set(draft, [...key, 'smart_objects'], []);
        return draft;
      }
    case actionTypes.RESYNCHRONIZE_MODULE_SMART_OBJECTS:
      {
        const {
          moduleId,
          smartObjects
        } = payload;
        const tree = findTreeWithCellNameImmer(draft, moduleId);
        if (tree) {
          copyLayoutSectionFromSchemaToContentIfNeededImmer(draft, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = get(draft, ['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(moduleId);
          ({
            tree: newTree
          } = newTree.mergeIntoCellParams(cell.getName(), {
            smart_objects: smartObjects
          }));
          return set(draft, ['layoutSectionTrees', tree.getRootName()], newTree);
        }
        const keyBase = getKeyForNonLayoutSectionImmer(draft, moduleId);
        if (!keyBase) {
          logUnknownModuleToRaven(moduleId);
          return draft;
        }
        const key = [...keyBase, 'smart_objects'];
        return set(draft, key, smartObjects);
      }
    case actionTypes.CLONED_MODULES_QUEUE_CLEARED:
      {
        // Clear all nodes from pending width queue
        draft.clonedModulesPendingDomOperations = new Set([]);
        return draft;
      }
    case actionTypes.CLONED_STATIC_SECTION_MAP_CLEARED:
      {
        draft.mapOfClonedToOldStaticSectionName = {};
        return draft;
      }
    case actionTypes.ADDED_MODULES_TO_FAKE_MODULES:
      {
        const {
          modules
        } = payload;
        Object.assign(draft.fakeModules, modules);
        return draft;
      }
    case actionTypes.ADDED_CUSTOM_UPDATES_FOR_FAKE_MODULES:
      {
        const {
          customUpdates
        } = payload;
        Object.assign(draft.fakeModuleCustomUpdates, customUpdates);
        return draft;
      }
    case actionTypes.CUSTOM_LAYOUT_SECTION_ADDED:
      {
        const {
          layoutSectionId,
          rowIdToInsertAround,
          targetBeforeOrAfter,
          isEmptyLayoutSection,
          rowIdToMove,
          tempCustomSectionTree,
          customSectionModuleSchemas
        } = payload;
        const tree = getLayoutSectionTreeToModifyImmer(draft, layoutSectionId);
        let newTree;
        let newOriginTree;
        let modifiedColumns;
        if (isEmptyLayoutSection) {
          ({
            tree: newTree,
            originTree: newOriginTree,
            modifiedColumns
          } = appendRowToCell(tree, layoutSectionId, {
            existingRowId: rowIdToMove,
            customSectionModuleSchemas,
            originTree: tempCustomSectionTree
          }));
        } else {
          const insertMethod = targetBeforeOrAfter === BEFORE ? insertRowBefore : insertRowAfter;
          ({
            tree: newTree,
            originTree: newOriginTree,
            modifiedColumns
          } = insertMethod(tree, rowIdToInsertAround, {
            existingRowId: rowIdToMove,
            originTree: tempCustomSectionTree
          }));
        }
        updateLayoutSectionTreeAndWidgetsImmer({
          layoutSectionId,
          customSectionModuleSchemas,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          draft
        });
        return draft;
      }
    case actionTypes.UPDATE_STATIC_MODULE_WITH_NEW_ID:
      {
        const {
          id,
          newModule
        } = payload;
        const newModuleAsJs = maybeToJS(newModule);
        set(draft, ['widgets', newModuleAsJs.name], newModuleAsJs);
        set(draft, ['schemaWidgets', newModuleAsJs.name], newModuleAsJs);
        unset(draft, ['schemaWidgets', id]);
        unset(draft, ['widgets', id]);
        return draft;
      }
    case actionTypes.RESET_LAYOUT_SECTION_TO_TEMPLATE_DEFAULT:
      {
        const {
          id
        } = payload;
        copyLayoutSectionFromSchemaToContentImmer(draft, id, draft.layoutSectionWidgets);
        return draft;
      }
    case actionTypes.ADD_NEW_EMBED_TO_EMBED_INFO:
      {
        const {
          id,
          embedInfo
        } = payload;
        const idAsString = `${id}`;
        if (!has(draft, ['embedInfo', idAsString])) {
          set(draft, ['embedInfo', idAsString], embedInfo);
        }
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_ELEMENT_INSERTED_BEFORE:
      {
        const {
          containerId,
          targetedElementId,
          gridLayoutId,
          existingNodeId,
          content,
          newModuleSchemaJson
        } = action.payload;
        let newTree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        if (existingNodeId) {
          ({
            tree: newTree
          } = newTree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: containerId,
            beforeNodeId: targetedElementId
          }));
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          newTree = newTree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId,
            beforeNodeId: targetedElementId
          });
        }
        draft.gridLayoutTrees[gridLayoutId] = newTree;
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_DROP_ON_PEGBOARD:
      {
        const uncastedPayload = action.payload;
        const {
          existingNodeId,
          gridLayoutId,
          containerId,
          newModuleSchemaJson,
          row,
          column
        } = uncastedPayload;
        let newTree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        if (existingNodeId) {
          const existingNode = newTree.findNode(existingNodeId);
          if (!existingNode.isModule()) {
            return draft;
          }
          if (existingNode.getParentNodeId() !== containerId) {
            ({
              tree: newTree
            } = newTree.moveNode({
              nodeId: existingNodeId,
              destParentNodeId: containerId
            }));
          }
          ({
            tree: newTree
          } = newTree.mergeModuleStyles(existingNodeId, {
            breakpointName: 'default',
            styleType: 'editorProvidedModuleBreakpointStyles'
          }, {
            gridPosition: {
              __typename: ManualPositionTypename,
              type: 'MANUAL',
              rowStart: row,
              columnStart: column
            }
          }));
          draft.gridLayoutTrees[gridLayoutId] = newTree;
        } else if (newModuleSchemaJson) {
          const newGridContent = prepareNewGridModuleDataHelper(newModuleSchemaJson);
          if (!newGridContent) return draft;
          newTree = newTree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId
          });
          ({
            tree: newTree
          } = newTree.mergeModuleStyles(newGridContent.id, {
            breakpointName: 'default',
            styleType: 'editorProvidedModuleBreakpointStyles'
          }, {
            gridPosition: {
              __typename: ManualPositionTypename,
              type: 'MANUAL',
              rowStart: row,
              columnStart: column
            },
            gridSpanning: {
              rowsSpanned: 2,
              columnsSpanned: 4
            }
          }));
          draft.gridLayoutTrees[gridLayoutId] = newTree;
        }
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_ELEMENT_INSERTED_AFTER:
      {
        const {
          containerId,
          targetedElementId,
          gridLayoutId,
          existingNodeId,
          newModuleSchemaJson,
          content
        } = action.payload;
        let newTree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        if (existingNodeId) {
          ({
            tree: newTree
          } = newTree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: containerId,
            afterNodeId: targetedElementId
          }));
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          newTree = newTree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId,
            afterNodeId: targetedElementId
          });
        }
        draft.gridLayoutTrees[gridLayoutId] = newTree;
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_INSERT_BLANK_SECTION:
      {
        const uncastedPayload = action.payload;
        const {
          gridLayoutId,
          beforeNodeId,
          afterNodeId,
          newSectionLayout
        } = uncastedPayload;
        const tree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        const {
            child: newContainer
          } = newSectionLayout,
          newSection = _objectWithoutPropertiesLoose(newSectionLayout, _excluded);
        const {
          tree: newTreeToInsertChild,
          node: newSectionNode
        } = tree.insertNewNode({
          newNodeValue: newSection,
          parentNodeId: tree.getRootId(),
          beforeNodeId,
          afterNodeId
        });
        const {
          tree: newTreeToInsertChildren,
          node: newContainerNode
        } = newTreeToInsertChild.insertNewNode({
          newNodeValue: newContainer,
          parentNodeId: newSectionNode.getId(),
          beforeNodeId,
          afterNodeId
        });
        let finalTree = newTreeToInsertChildren;
        if (isContainer(newContainer)) {
          newContainer.children.forEach(child => {
            const {
              tree: newTree
            } = finalTree.insertNewNode({
              newNodeValue: child,
              parentNodeId: newContainerNode.getId(),
              beforeNodeId,
              afterNodeId
            });
            finalTree = newTree;
          });
        }
        draft.gridLayoutTrees[gridLayoutId] = finalTree;
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_MOVE_SECTION_BEFORE:
      {
        const {
          gridLayoutId,
          existingNodeId,
          parentId,
          targetedSectionId
        } = action.payload;
        const tree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        if (existingNodeId) {
          const {
            tree: newTree
          } = tree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: parentId,
            beforeNodeId: targetedSectionId
          });
          draft.gridLayoutTrees[gridLayoutId] = newTree;
        }
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_MOVE_SECTION_AFTER:
      {
        const {
          gridLayoutId,
          existingNodeId,
          parentId,
          targetedSectionId
        } = action.payload;
        const tree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        if (existingNodeId) {
          const {
            tree: newTree
          } = tree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: parentId,
            afterNodeId: targetedSectionId
          });
          draft.gridLayoutTrees[gridLayoutId] = newTree;
        }
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_INSERTED_IN_EMPTY_STACK:
      {
        const {
          containerId,
          gridLayoutId,
          existingNodeId,
          newModuleSchemaJson,
          content
        } = action.payload;
        let newTree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        if (existingNodeId) {
          ({
            tree: newTree
          } = newTree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: containerId
          }));
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          newTree = newTree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId
          });
        }
        draft.gridLayoutTrees[gridLayoutId] = newTree;
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_INSERTED_IN_EMPTY_GRID_LAYOUT:
      {
        const {
          gridLayoutId,
          newModuleSchemaJson,
          content
        } = action.payload;
        let newTree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        if (content || newModuleSchemaJson) {
          let newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          if (newGridContent.type === GRID_NODE_TYPES.MODULE) {
            const containerWrapper = {
              __typename: ContainerTypename,
              type: GRID_NODE_TYPES.CONTAINER,
              id: generateUniqueId('container-'),
              children: [newGridContent],
              layout: {
                layout: {
                  default: {
                    __typename: StackContainerLayoutTypename,
                    type: 'STACK',
                    direction: 'HORIZONTAL'
                  }
                }
              },
              styles: {
                breakpointStyles: {
                  default: {
                    backgroundLayers: []
                  }
                }
              }
            };
            newGridContent = {
              type: GRID_NODE_TYPES.SECTION,
              id: generateUniqueId('section-'),
              styles: {
                breakpointStyles: {}
              },
              child: containerWrapper
            };
          } else if (newGridContent.type === GRID_NODE_TYPES.CONTAINER) {
            newGridContent = {
              type: GRID_NODE_TYPES.SECTION,
              id: generateUniqueId('section-'),
              styles: {
                breakpointStyles: {}
              },
              child: newGridContent
            };
          }
          newTree = newTree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: gridLayoutId
          });
        }
        draft.gridLayoutTrees[gridLayoutId] = newTree;
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_INSERTED_IN_TABLE_CELL:
      {
        const {
          containerId,
          targetedCellId,
          gridLayoutId,
          content,
          existingNodeId,
          newModuleSchemaJson
        } = action.payload;
        const tree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        if (existingNodeId) {
          const existingNode = tree.findNode(existingNodeId);
          if (
          // If the existing node is being rearranged within the containing grid
          existingNode.getParentNodeId() === containerId && existingNode.isGridContainerCell()) {
            const parentNode = existingNode.getParentNode();
            const indexOfExistingNode = parentNode.indexOfChildNode(existingNodeId);
            const indexOfTargetedCell = parentNode.indexOfChildNode(targetedCellId);

            // If the existing node is being moved forward in the grid, we want
            // to swap the positions of the existing node and the targeted cell
            if (indexOfTargetedCell > indexOfExistingNode) {
              if (indexOfTargetedCell - indexOfExistingNode === 1) {
                // Since the node is immediately next to the targeted cell,
                // place it after the targeted cell
                const {
                  tree: newTree
                } = tree.moveNode({
                  nodeId: existingNodeId,
                  destParentNodeId: containerId,
                  afterNodeId: targetedCellId
                });
                draft.gridLayoutTrees[gridLayoutId] = newTree;
              } else {
                // If the node is not next to the targeted cell, we need to
                // move the node after the targeted cell and then move the
                // targeted cell to the position of the existing node
                const nodeIdAfterExistingNode = parentNode.getChildNodeIds()[indexOfExistingNode + 1];
                const {
                  tree: tempTreeToSwapTargetedCell
                } = tree.moveNode({
                  nodeId: existingNodeId,
                  destParentNodeId: containerId,
                  afterNodeId: targetedCellId
                });
                const {
                  tree: newTree2
                } = tempTreeToSwapTargetedCell.moveNode({
                  nodeId: targetedCellId,
                  destParentNodeId: containerId,
                  beforeNodeId: nodeIdAfterExistingNode
                });
                draft.gridLayoutTrees[gridLayoutId] = newTree2;
              }
            } else {
              // If the existing node is being moved backward in the grid, we
              // instead put the existing node behind the targeted cell
              const {
                tree: newTree
              } = tree.moveNode({
                nodeId: existingNodeId,
                destParentNodeId: containerId,
                beforeNodeId: targetedCellId
              });
              draft.gridLayoutTrees[gridLayoutId] = newTree;
            }
          } else {
            // Else, the node is coming from outside the grid
            const {
              tree: newTree
            } = tree.moveNode({
              nodeId: existingNodeId,
              destParentNodeId: containerId,
              afterNodeId: targetedCellId
            });
            draft.gridLayoutTrees[gridLayoutId] = newTree;
          }
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          const newTree = tree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId,
            afterNodeId: targetedCellId
          });
          draft.gridLayoutTrees[gridLayoutId] = newTree;
        }
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_APPENDED_GRID_CELL:
      {
        const {
          containerId,
          lastChildId,
          gridLayoutId,
          existingNodeId,
          content,
          newModuleSchemaJson
        } = action.payload;
        const tree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        if (existingNodeId) {
          const {
            tree: newTree
          } = tree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: containerId,
            afterNodeId: lastChildId
          });
          draft.gridLayoutTrees[gridLayoutId] = newTree;
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          const newTree = tree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId,
            afterNodeId: lastChildId
          });
          draft.gridLayoutTrees[gridLayoutId] = newTree;
        }
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_INSERTED_AFTER_TABLE_CELL:
      {
        const {
          containerId,
          nextSiblingId,
          gridLayoutId,
          existingNodeId,
          content,
          newModuleSchemaJson
        } = action.payload;
        const tree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        if (existingNodeId) {
          const {
            tree: newTree
          } = tree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: containerId,
            beforeNodeId: nextSiblingId
          });
          draft.gridLayoutTrees[gridLayoutId] = newTree;
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          const newTree = tree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId,
            beforeNodeId: nextSiblingId
          });
          draft.gridLayoutTrees[gridLayoutId] = newTree;
        }
        return draft;
      }

    // TODO: Implement moduleReducer logic for wrap and insert drop targets.
    case actionTypes.GRID_LAYOUTS_WRAP_AND_INSERT_ABOVE_CONTAINER:
    case actionTypes.GRID_LAYOUTS_WRAP_AND_INSERT_BELOW_CONTAINER:
      {
        const {
          gridLayoutId,
          existingNodeId,
          containerId,
          parentId,
          content,
          newModuleSchemaJson
        } = action.payload;
        let newTree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        const newNodePositionParams = action.type === actionTypes.GRID_LAYOUTS_WRAP_AND_INSERT_ABOVE_CONTAINER ? {
          beforeNodeId: containerId
        } : {
          afterNodeId: containerId
        };
        const newContainer = createGridContainer(BUILDING_BLOCK_TYPES.VERTICAL_STACK);
        ({
          tree: newTree
        } = newTree.wrapSectionContainer({
          sectionId: parentId,
          newSectionContainerNodeValue: newContainer
        }));
        if (existingNodeId) {
          ({
            tree: newTree
          } = newTree.moveNode(Object.assign({
            nodeId: existingNodeId,
            destParentNodeId: newContainer.id
          }, newNodePositionParams)));
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          ({
            tree: newTree
          } = newTree.insertNewNode(Object.assign({
            newNodeValue: newGridContent,
            parentNodeId: newContainer.id
          }, newNodePositionParams)));
        }
        draft.gridLayoutTrees[gridLayoutId] = newTree;
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_WRAP_AND_INSERT_LEFT_OF_CONTAINER:
    case actionTypes.GRID_LAYOUTS_WRAP_AND_INSERT_RIGHT_OF_CONTAINER:
      {
        const {
          gridLayoutId,
          existingNodeId,
          containerId,
          parentId,
          content,
          newModuleSchemaJson
        } = action.payload;
        let newTree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        const newNodePositionParams = action.type === actionTypes.GRID_LAYOUTS_WRAP_AND_INSERT_LEFT_OF_CONTAINER ? {
          beforeNodeId: containerId
        } : {
          afterNodeId: containerId
        };
        const newContainer = createGridContainer(BUILDING_BLOCK_TYPES.HORIZONTAL_STACK);
        ({
          tree: newTree
        } = newTree.wrapSectionContainer({
          sectionId: parentId,
          newSectionContainerNodeValue: newContainer
        }));
        if (existingNodeId) {
          ({
            tree: newTree
          } = newTree.moveNode(Object.assign({
            nodeId: existingNodeId,
            destParentNodeId: newContainer.id
          }, newNodePositionParams)));
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          ({
            tree: newTree
          } = newTree.insertNewNode(Object.assign({
            newNodeValue: newGridContent,
            parentNodeId: newContainer.id
          }, newNodePositionParams)));
        }
        draft.gridLayoutTrees[gridLayoutId] = newTree;
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_NODE_CLONED_AND_INSERTED_AFTER_ORIGINAL:
      {
        const uncastedPayload = action.payload;
        const {
          gridLayoutId,
          nodeId
        } = uncastedPayload;
        const tree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        const node = tree.findNode(nodeId);
        // If the node is a container and a child of a section, we need to clone
        // the parent section instead, since sections must have exactly one child
        if (node.isContainer() && node.isChildOfSection()) {
          const {
            tree: newTree,
            node: clonedNode,
            clonedIdToOriginalIdMap
          } = tree.cloneNode({
            nodeId: node.getParentNodeId()
          });
          copyClonedModulesToGridLayoutModulesImmer(draft, clonedNode, clonedIdToOriginalIdMap);
          draft.gridLayoutTrees[gridLayoutId] = newTree;
        } else {
          const {
            tree: newTree,
            node: clonedNode,
            clonedIdToOriginalIdMap
          } = tree.cloneNode({
            nodeId
          });
          copyClonedModulesToGridLayoutModulesImmer(draft, clonedNode, clonedIdToOriginalIdMap);
          draft.gridLayoutTrees[gridLayoutId] = newTree;
        }
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_SECTION_DELETED:
    case actionTypes.GRID_LAYOUTS_CONTAINER_DELETED:
    case actionTypes.GRID_LAYOUTS_MODULE_DELETED:
      {
        const uncastedPayload = action.payload;
        const {
          gridLayoutId,
          nodeId
        } = uncastedPayload;
        const tree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        const {
          tree: newTree
        } = tree.removeNode(nodeId);
        draft.gridLayoutTrees[gridLayoutId] = newTree;
        return draft;
      }
    case actionTypes.WRAP_IN_STACK:
      {
        const uncastedPayload = action.payload;
        const {
          parentId,
          gridLayoutId,
          nodeId
        } = uncastedPayload;
        const tree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        const parentNode = tree.findNode(parentId);
        if (!parentNode.isContainer()) {
          return draft;
        }
        const stackType = computeWrappingStackTypeFromParentNode(parentNode);
        const newContainer = createGridContainer(stackType);
        let {
          tree: newTree
        } = tree.insertNewNode({
          newNodeValue: newContainer,
          parentNodeId: parentId,
          afterNodeId: nodeId
        });
        ({
          tree: newTree
        } = newTree.moveNode({
          nodeId,
          destParentNodeId: newContainer.id
        }));
        draft.gridLayoutTrees[gridLayoutId] = newTree;
        return draft;
      }
    case actionTypes.GRID_SET_OLD_MODULE_STYLES:
      {
        const uncastedPayload = action.payload;
        const {
          nodeId,
          gridLayoutId,
          styles
        } = uncastedPayload;
        const currentTree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        const convertedCss = styles !== null && styles !== void 0 && styles.css ? Object.entries(styles.css).reduce((acc, [key, value]) => {
          acc[key] = convertJsonToFieldValueAvroWithoutTypename(value);
          return acc;
        }, {}) : {};
        const convertedChildCss = styles !== null && styles !== void 0 && styles.child_css ? Object.entries(styles.child_css).reduce((acc, [key, value]) => {
          acc[key] = convertJsonToFieldValueAvroWithoutTypename(value);
          return acc;
        }, {}) : {};
        const oldModuleStyles = {
          css: convertedCss,
          childCss: convertedChildCss
        };
        const {
          tree
        } = currentTree.mergeModuleStyles(nodeId, {
          styleType: 'oldModuleStyles'
        }, oldModuleStyles);
        draft.gridLayoutTrees[gridLayoutId] = tree;
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_SET_NODE_STYLES:
      {
        const uncastedPayload = action.payload;
        const {
          nodeId,
          gridLayoutId,
          styles,
          isEditorProvidedModuleStyles,
          activeBreakpoint
        } = uncastedPayload;
        const currentTree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        if (isEditorProvidedModuleStyles) {
          const {
            tree
          } = currentTree.mergeModuleStyles(nodeId, {
            styleType: 'editorProvidedModuleBreakpointStyles',
            breakpointName: activeBreakpoint
          }, styles);
          draft.gridLayoutTrees[gridLayoutId] = tree;
        } else {
          const node = currentTree.findNode(nodeId);
          if (node.isContainer()) {
            const {
              tree
            } = currentTree.mergeContainerStyles(nodeId, activeBreakpoint, styles);
            draft.gridLayoutTrees[gridLayoutId] = tree;
          } else if (node.isSection()) {
            const {
              tree
            } = currentTree.mergeSectionStyles(nodeId, activeBreakpoint, styles);
            draft.gridLayoutTrees[gridLayoutId] = tree;
          }
        }
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_UPDATE_NODE_LAYOUT:
      {
        const uncastedPayload = action.payload;
        const {
          nodeId,
          gridLayoutId,
          activeBreakpoint,
          layoutType
        } = uncastedPayload;
        const tree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        const selectedNode = tree.findNode(nodeId);
        if (!selectedNode.isContainer()) {
          return draft;
        }
        const selectedNodeLayout = getContainerBreakpointLayout(selectedNode, activeBreakpoint);
        let newContainerLayout = selectedNodeLayout;
        if (layoutType === 'GRID') {
          if (isStackContainerLayout(selectedNodeLayout)) {
            const {
              rows,
              columns
            } = convertStackToGridLayout(selectedNode.getChildNodes().length, selectedNodeLayout.direction);
            newContainerLayout = {
              __typename: GridContainerLayoutTypename,
              type: 'GRID',
              rows,
              columns
            };
          }
        } else {
          newContainerLayout = {
            __typename: StackContainerLayoutTypename,
            type: 'STACK',
            direction: layoutType
          };
        }
        const {
          tree: newTree
        } = tree.mergeContainerLayout(nodeId, activeBreakpoint, newContainerLayout);
        draft.gridLayoutTrees[gridLayoutId] = newTree;
        return draft;
      }
    case actionTypes.GRID_LAYOUTS_UPDATE_TABLE_DEFINITION:
      {
        const uncastedPayload = action.payload;
        const {
          nodeId,
          gridLayoutId,
          activeBreakpoint,
          newRows,
          newColumns
        } = uncastedPayload;
        const tree = getGridLayoutTreeToModifyImmer(draft, gridLayoutId);
        const {
          tree: newTree
        } = tree.mergeContainerLayout(nodeId, activeBreakpoint, {
          __typename: GridContainerLayoutTypename,
          type: 'GRID',
          rows: newRows,
          columns: newColumns
        });
        draft.gridLayoutTrees[gridLayoutId] = newTree;
        return draft;
      }
    default:
      return draft;
  }
});
const moduleReducer = (state = moduleReducerInitialState,
// @ts-ignore will be migrated
action = {}) => {
  const {
    type,
    payload
  } = action;

  // Check if any of the fake modules should update from this action
  if (state.hasIn(['fakeModuleCustomUpdates', type])) {
    const {
      moduleName,
      updatePath
    } = state.getIn(['fakeModuleCustomUpdates', type]).toJS();
    const {
      metaData,
      isFakeUndoRedoProxiedUpdate
    } = action;

    // A fake undo redo proxied update is used by fakeUndoRedoUpdatesMiddleware. It should be ignored by this undoable module reducer
    // (but listened to by other non undoable reducers)
    if (!isFakeUndoRedoProxiedUpdate) {
      state = updateMetaDataForModule(state, moduleName, metaData);
      state = incrementModuleEditVersion({
        state,
        id: moduleName
      });
      if (metaData.updatedRichTextModuleName) {
        state = incrementModuleEditVersion({
          state,
          id: metaData.updatedRichTextModuleName
        });
      }
      const fakeModuleUpdatePath = ['fakeModules', moduleName, 'body', ...updatePath];
      const newValue = updatePath.reduce(
      // @ts-ignore will be migrated
      (current, key) => !isNil(current[key]) ? current[key] : payload, payload);
      if (state.getIn(fakeModuleUpdatePath) !== newValue) {
        state = state.setIn(fakeModuleUpdatePath, newValue);
      }
    }
  }

  // Test Flag for https://git.hubteam.com/HubSpot/ContentEditorUI/issues/6194 (that triggers a few different behaviors)
  const doNotWrapSingleModuleInSection = hasTestFlag(DND_DO_NOT_WRAP_SINGLE_MODULE_IN_SECTION_FLAG);
  const shouldRemoveUnnecessaryWrappersForSingleColumnSection = doNotWrapSingleModuleInSection;
  state = state.set('themePageOverrides', themePageOverridesReducer(state.get('themePageOverrides'), action));
  switch (type) {
    case actionTypes.SET_FLEX_AREA_INDEX:
      {
        return state.merge({
          flexAreasMetadata: {
            [DND_AREA_ID]: action.index
          }
        });
      }
    case actionTypes.FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        const contentSchema = action.response;
        const {
          schema,
          content,
          isNewEmail,
          grid_layouts: gridLayouts
        } = contentSchema;
        // @ts-ignore will be migrated
        let schemaLayoutSectionTrees = new Immutable.Map();
        // @ts-ignore will be migrated
        let layoutSectionTrees = new Immutable.Map();
        // @ts-ignore will be migrated
        let uneditableWidgets = new Immutable.Map();
        // @ts-ignore will be migrated
        let allWidgetNamesInFlexColumns = new Immutable.Set();
        // @ts-ignore will be migrated
        let flexAreaTree = new Immutable.Map();
        const embedInfo = schema.embed_info ? Immutable.fromJS(schema.embed_info) :
        // @ts-ignore will be migrated
        new Immutable.Map();
        // @ts-ignore will be migrated
        let schemaGridLayoutTrees = new Immutable.Map();
        // @ts-ignore will be migrated
        let gridLayoutTrees = new Immutable.Map();
        const {
          default_grid_layouts: schemaGridLayouts,
          grid_layout_modules: schemaGridLayoutModules
        } = schema;
        const gridLayoutModules = !schemaGridLayoutModules || isEmptyObject(schemaGridLayoutModules) ? initializeGridLayoutModules(schemaGridLayouts) : schemaGridLayoutModules;
        const {
          isCustomEmail
        } = action;
        const templateContainsFlexArea = Object.keys(schema.flex_areas).length > 0;
        const isNewEmailUsingCustomTemplateWithDndArea = isCustomEmail && templateContainsFlexArea && isNewEmail;
        if (isNewEmailUsingCustomTemplateWithDndArea) {
          UsageTracker.track('newDndInCustom');
        }
        flexAreaTree = maybeParseFlexAreaTree({
          content,
          templateContainsFlexArea
        });
        if (schema.widget_containers) {
          Object.keys(schema.widget_containers).forEach(containerName => {
            if (schema.widget_containers[containerName].widgets) {
              schema.widget_containers[containerName].widgets.forEach(
              // @ts-ignore will be migrated
              widget => {
                allWidgetNamesInFlexColumns = allWidgetNamesInFlexColumns.add(widget.name);
              });
            }
          });
        }
        if (schema.layout_sections) {
          Object.keys(schema.layout_sections).forEach(lsId => {
            const nodeNameQueueWriter = createAddToQueue('schema', lsId);
            createNodeNameQueueForTree('schema', lsId);
            schemaLayoutSectionTrees = schemaLayoutSectionTrees.set(lsId, importTreeFromLayoutDataApi(schema.layout_sections[lsId], {
              shouldPreventEmptyRows: false,
              CellClass: CustomCellTweakingAutoDeleteLogicPerTestFlag,
              nodeNameQueueWriter
            }));
          });
        }
        if (content.layoutSections) {
          Object.keys(content.layoutSections).forEach(lsId => {
            createNodeNameQueueForTree('content', lsId);
            layoutSectionTrees = layoutSectionTrees.set(lsId, importTreeFromLayoutDataApi(content.layoutSections[lsId], {
              shouldPreventEmptyRows: false,
              CellClass: CustomCellTweakingAutoDeleteLogicPerTestFlag,
              nodeNameQueueWriter: createAddToQueue('content', lsId)
            }));
          });
        }
        if (gridLayouts) {
          Object.keys(gridLayouts).forEach(glId => {
            const generatedIdQueueWriter = createAddToGeneratedIdQueue('content', glId);
            createGeneratedIdQueueForGridLayoutTree('content', glId);
            gridLayoutTrees = gridLayoutTrees.set(glId, GridLayoutDataTree.createTreeFromGridLayoutDataApi(gridLayouts[glId], {
              generatedIdQueueWriter
            }));
          });
        }

        // Build the schema grid layout trees
        if (schemaGridLayouts) {
          Object.keys(schemaGridLayouts).forEach(glId => {
            const generatedIdQueueWriter = createAddToGeneratedIdQueue('schema', glId);
            createGeneratedIdQueueForGridLayoutTree('schema', glId);
            const options = {
              generatedIdQueueWriter
            };
            if (schemaGridLayoutModules) {
              options.transformNodeValueCallback = getHydrateMissingPropertiesInGridLayoutTree(schemaGridLayoutModules, glId);
            }
            schemaGridLayoutTrees = schemaGridLayoutTrees.set(glId, GridLayoutDataTree.createTreeFromGridLayoutDataApi(schemaGridLayouts[glId], options));
          });
        }

        // Collect all non-overrideable modules (that are not in flex columns) to store those on uneditableWidgets
        if (schema.all_widgets) {
          // @ts-ignore will be migrated
          schema.all_widgets.forEach(widget => {
            if ((widget.global_partial || !widget.overrideable) &&
            // TODO Branden can eventually remove this
            !allWidgetNamesInFlexColumns.has(widget.name) && !widget.layout_section_name) {
              uneditableWidgets = uneditableWidgets.set(widget.name, Immutable.fromJS(widget));
            }
          });
        }

        // Omit order from values inside layout_section_widgets
        const orderlessLayoutSectionWidgets = Immutable.fromJS(schema.layout_section_widgets || {}
        // @ts-ignore will be migrated
        ).map(moduleList =>
        // @ts-ignore will be migrated
        moduleList.map(m => m.filterNot((v, k) => k === 'order')));
        const orderlessGridLayoutModules = Immutable.fromJS(gridLayoutModules || {}
        // @ts-ignore will be migrated
        ).map(moduleList =>
        // @ts-ignore will be migrated
        moduleList.map(m => m.filterNot((v, k) => k === 'order')));

        // Filter out any `deleted_at` content widgets outside of containers (except for email bodies
        // to match https://git.hubteam.com/HubSpot/content4j/blob/2452d91c0c59af09e11112894796800c2c59a3e9/ContentModel/src/main/java/com/hubspot/content/model/Content.java#L439-L442 )
        const filteredContentWidgets = omit(content.widgets,
        // @ts-ignore will be migrated
        widget => Boolean(widget.deleted_at) && !isEmailBodyName(widget.name));
        const widgetContainers = normalizeFlexColumnData(content.widgetContainers, schema.widget_containers);
        return state.merge({
          uneditableWidgets,
          schemaLayoutSectionTrees,
          layoutSectionTrees,
          schemaGridLayoutTrees,
          gridLayoutTrees,
          gridLayoutModules: orderlessGridLayoutModules,
          flexAreaTree,
          // NOTE, trying to removing this but still need for now
          layoutSectionWidgets: orderlessLayoutSectionWidgets,
          schemaWidgetContainers: schema.widget_containers,
          widgetContainers,
          schemaWidgets: omit(schema.widgets, ['preview_text']),
          // instead lives in previewTextReducer
          widgets: omit(filteredContentWidgets, ['preview_text']),
          contentCss: content.css || {},
          widgetsInRichText: Immutable.fromJS(schema.widgets_in_rich_text || {}),
          embedInfo
        });
      }
    case actionTypes.FETCH_TEMPLATE_SCHEMA_SUCCEEDED:
      {
        const templateSchema = action.response;
        const {
          schema
        } = templateSchema;
        // @ts-ignore will be migrated
        const schemaLayoutSectionTrees = new Immutable.Map();
        // @ts-ignore will be migrated
        const layoutSectionTrees = new Immutable.Map();
        // @ts-ignore will be migrated
        const uneditableWidgets = new Immutable.Map();
        const orderlessLayoutSectionWidgets = Immutable.fromJS({});

        // Filter out any `deleted_at` content widgets outside of containers (except for email bodies
        // to match https://git.hubteam.com/HubSpot/content4j/blob/2452d91c0c59af09e11112894796800c2c59a3e9/ContentModel/src/main/java/com/hubspot/content/model/Content.java#L439-L442 )
        const filteredContentWidgets = omit(schema.all_widgets,
        // @ts-ignore will be migrated
        widget => Boolean(widget.deleted_at) && !isEmailBodyName(widget.name));
        const widgetContainers = normalizeFlexColumnData([]);
        return state.merge({
          uneditableWidgets,
          schemaLayoutSectionTrees,
          layoutSectionTrees,
          // NOTE, trying to removing this but still need for now
          layoutSectionWidgets: orderlessLayoutSectionWidgets,
          schemaWidgetContainers: schema.widget_containers || [],
          widgetContainers,
          schemaWidgets: omit(schema.all_widgets, ['preview_text']),
          // instead lives in previewTextReducer
          widgets: omit(filteredContentWidgets, ['preview_text']),
          contentCss: {}
        });
      }
    case SET_INSTANCE_DATA_SUCCEEDED:
      {
        // When the instance loads into the editor make sure any inserted modules in rich text
        // are included
        if (payload.values && payload.values[DefaultInstanceColumns.hs_modules_in_richtext]) {
          const modulesInRichText = getInsertedModulesFromRichText(payload.values[DefaultInstanceColumns.hs_modules_in_richtext]);
          return setInsertedModulesFromRichTextImmutable(state, modulesInRichText);
        }
        return state;
      }
    case UPDATE_CURRENT_INSTANCE_VALUE:
      {
        // When a module in rich text is updated we need to update it in the module state
        if (payload.fieldKey === MODULES_IN_RICHTEXT) {
          const modulesInRichText = getInsertedModulesFromRichText(payload.newVal);
          return setInsertedModulesFromRichTextImmutable(state, modulesInRichText);
        }
        return state;
      }
    case ADD_MODULES_TO_RICH_TEXT_PROPERTY:
      {
        // When adding or cloning modules within SCP RichText instances make sure we are adding them to module reducer
        if (payload.newModuleInstances) {
          const newModules = getIndexedModuleInstances(payload.newModuleInstances);
          return setInsertedModulesFromRichTextImmutable(state, newModules);
        }
        return state;
      }
    case DELETE_MODULES_IN_RICH_TEXT_PROPERTY:
      {
        if (payload.removedModuleInstances) {
          return deleteInsertedModulesFromRichTextImmutable(state, payload.removedModuleInstances);
        }
        return state;
      }
    case actionTypes.MOVED_MODULE:
      {
        const {
          movingModuleId,
          newIndex,
          newColumnId
        } = payload;
        const key = getKeyForNonLayoutSection(state, movingModuleId);
        if (!key) {
          logUnknownModuleToRaven(movingModuleId);
          return state;
        }
        const module = state.getIn(key);
        state = removeModule(state, movingModuleId);
        return addModuleToFlexColumnHelper(state, newColumnId, newIndex, module);
      }
    case actionTypes.ADDED_MODULE:
      {
        const {
          module,
          containerId,
          index
        } = payload;
        return addModuleToFlexColumnHelper(state, containerId, index, Immutable.fromJS(module));
      }
    case actionTypes.DELETED_MODULE:
      {
        const {
          id
        } = payload;
        return removeModule(state, id);
      }
    case actionTypes.ADDED_MODULES_TO_POST_BODY:
      {
        const {
          modules
        } = payload;
        const widgetsInRichText = state.get('widgetsInRichText')
        // @ts-ignore will be migrated
        .withMutations(widgets => {
          // @ts-ignore will be migrated
          modules.forEach(module => {
            if (widgets.has(module.name)) {
              throw new Error(`ERROR module exists in widgetsInRichText`, {
                // @ts-ignore will be migrated
                moduleName: module.name
              });
            }
            widgets.set(module.name, Immutable.fromJS(module));
          });
        });
        return state.set('widgetsInRichText', widgetsInRichText);
      }
    case actionTypes.LAYOUT_SECTION_MODULE_DELETED:
      {
        const {
          layoutSectionId,
          moduleId
        } = payload;
        return removeCellFromLayoutSection(state, layoutSectionId, moduleId, {
          shouldRemoveUnnecessaryWrappersForSingleColumnSection
        });
      }
    case actionTypes.LAYOUT_SECTION_COLUMN_DELETED:
      {
        const {
          layoutSectionId,
          columnId
        } = payload;
        return removeCellFromLayoutSection(state, layoutSectionId, columnId, {
          shouldRemoveUnnecessaryWrappersForSingleColumnSection
        });
      }
    case actionTypes.LAYOUT_SECTION_ROW_DELETED:
      {
        const {
          layoutSectionId,
          rowId
        } = payload;
        return removeRowFromLayoutSection(state, layoutSectionId, rowId);
      }
    case actionTypes.LAYOUT_SECTION_INSERTED_IN_EMPTY_ROW:
      {
        const {
          rowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModify(state, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = appendColumnToEmptyRow(tree, rowId, {
          existingColumnId,
          newModuleSchemaJson,
          originTree
        });
        // Bail if this tree action was a no-op
        if (tree === newTree && originTree === newOriginTree) {
          return state;
        }
        return updateLayoutSectionTreeAndWidgets({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          state
        });
      }
    case actionTypes.LAYOUT_SECTION_COLUMN_INSERTED_AFTER:
      {
        const {
          columnId,
          existingRowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModify(state, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = insertColumnAfter(tree, columnId, {
          existingColumnId,
          existingRowId,
          newModuleSchemaJson,
          originTree
        });
        // Bail if this tree action was a no-op
        if (tree === newTree && originTree === newOriginTree) {
          return state;
        }
        return updateLayoutSectionTreeAndWidgets({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          state
        });
      }
    case actionTypes.LAYOUT_SECTION_COLUMN_INSERTED_BEFORE:
      {
        const {
          columnId,
          existingRowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModify(state, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = insertColumnBefore(tree, columnId, {
          existingColumnId,
          existingRowId,
          newModuleSchemaJson,
          originTree
        });
        // Bail if this tree action was a no-op
        if (tree === newTree && originTree === newOriginTree) {
          return state;
        }
        return updateLayoutSectionTreeAndWidgets({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          state
        });
      }
    case actionTypes.LAYOUT_SECTION_ROW_INSERTED_AFTER:
      {
        const {
          rowId,
          existingRowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          shouldWrapSingleModuleInSection = !doNotWrapSingleModuleInSection,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModify(state, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = insertRowAfter(tree, rowId, {
          existingColumnId,
          existingRowId,
          newModuleSchemaJson,
          originTree,
          shouldWrapSingleModuleInSection
        });
        // Bail if this tree action was a no-op
        if (tree === newTree && originTree === newOriginTree) {
          return state;
        }
        return updateLayoutSectionTreeAndWidgets({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          state
        });
      }
    case actionTypes.LAYOUT_SECTION_ROW_INSERTED_BEFORE:
      {
        const {
          rowId,
          existingRowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          shouldWrapSingleModuleInSection = !doNotWrapSingleModuleInSection,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModify(state, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = insertRowBefore(tree, rowId, {
          existingColumnId,
          existingRowId,
          newModuleSchemaJson,
          originTree,
          shouldWrapSingleModuleInSection
        });
        // Bail if this tree action was a no-op
        if (tree === newTree && originTree === newOriginTree) {
          return state;
        }
        return updateLayoutSectionTreeAndWidgets({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          state
        });
      }
    case actionTypes.LAYOUT_SECTION_ROW_CLONED_BELOW:
      {
        const {
          rowId,
          layoutSectionId
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const {
          tree: newTree,
          modifiedColumns,
          mapOfClonedToOldNodeName
        } = tree.cloneNewRowBelow(rowId);

        // Bail if this tree action was a no-op
        if (tree === newTree) {
          return state;
        }
        return updateLayoutSectionTreeAndWidgets({
          layoutSectionId,
          modifiedColumns,
          tree: newTree,
          state,
          mapOfClonedToOldNodeName
        });
      }
    case actionTypes.LAYOUT_SECTION_CELL_CLONED_TO_RIGHT:
      {
        const {
          cellId,
          layoutSectionId
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        let cellToClone = cellId;

        // If cloning a single module in a column, clone the parent column instead
        const cell = tree.findCell(cellId);
        if (cell.isOnlyModuleInWrapperColumn()) {
          cellToClone = cell.getParent().getParentName();
        }
        const {
          tree: newTree,
          modifiedColumns,
          mapOfClonedToOldNodeName
        } = tree.cloneNewCellToRight(cellToClone);

        // Bail if this tree action was a no-op
        if (tree === newTree) {
          return state;
        }
        return updateLayoutSectionTreeAndWidgets({
          layoutSectionId,
          modifiedColumns,
          tree: newTree,
          state,
          mapOfClonedToOldNodeName
        });
      }
    case actionTypes.LAYOUT_SECTION_INSERTED_IN_EMPTY_COLUMN:
    case actionTypes.LAYOUT_SECTION_ROW_APPENDED:
      {
        const {
          columnId,
          existingRowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          shouldWrapSingleModuleInSection = !doNotWrapSingleModuleInSection,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModify(state, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = appendRowToCell(tree, columnId, {
          existingColumnId,
          existingRowId,
          newModuleSchemaJson,
          originTree,
          shouldWrapSingleModuleInSection
        });
        return updateLayoutSectionTreeAndWidgets({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          state
        });
      }
    case actionTypes.LAYOUT_SECTION_ROW_PREPENDED:
      {
        const {
          columnId,
          existingRowId,
          layoutSectionId,
          originLayoutSectionId,
          newModuleType,
          shouldWrapSingleModuleInSection = !doNotWrapSingleModuleInSection,
          existingColumnId
        } = payload;
        const newModuleSchemaJson = prepareNewModuleDataHelper(payload.newModuleSchemaJson, newModuleType);
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        let originTree;
        if (originLayoutSectionId !== layoutSectionId) {
          originTree = getLayoutSectionTreeToModify(state, originLayoutSectionId);
        }
        const {
          tree: newTree,
          originTree: newOriginTree,
          modifiedColumns
        } = prependRowToCell(tree, columnId, {
          existingColumnId,
          existingRowId,
          newModuleSchemaJson,
          originTree,
          shouldWrapSingleModuleInSection
        });
        // Bail if this tree action was a no-op
        if (tree === newTree && originTree === newOriginTree) {
          return state;
        }
        return updateLayoutSectionTreeAndWidgets({
          layoutSectionId,
          originLayoutSectionId,
          newModuleSchemaJson,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          state
        });
      }
    case actionTypes.MODULE_RESET_LAYOUT_STYLES:
    case actionTypes.LAYOUT_SECTION_CELL_RESET_LAYOUT_STYLES:
      {
        const {
          layoutSectionId,
          cellId
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const newTree = tree.mergeIntoCellValue(cellId, {
          styles: {}
        }).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.MOBILE_LAYOUT_SECTION_CELL_RESET_LAYOUT_STYLES:
      {
        const {
          layoutSectionId,
          cellId
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const newTree = tree.mergeIntoCellValue(cellId, {
          mobileMargin: {},
          mobilePadding: {}
        }, {
          path: ['styles']
        }).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.MODULE_SET_LAYOUT_STYLES:
    case actionTypes.LAYOUT_SECTION_CELL_SET_LAYOUT_STYLES:
      {
        const {
          layoutSectionId,
          cellId,
          newLayoutStyles
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const newTree = tree.mergeIntoCellStyles(cellId, newLayoutStyles).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.LAYOUT_SECTION_ROW_SET_LAYOUT_STYLES:
      {
        const {
          layoutSectionId,
          rowId,
          newLayoutStyles
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const newTree = tree.mergeIntoRowStyles(rowId, newLayoutStyles).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.SET_BREAKPOINT_STYLES_FOR_TREE_NODE:
      {
        const {
          layoutSectionId,
          nodeId,
          newLayoutStyles,
          breakpoint
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        let node;
        const isCell = tree.hasCell(nodeId);
        if (isCell) {
          node = tree.findCell(nodeId);
        } else {
          node = tree.findRow(nodeId);
        }
        if (node.isModule()) {
          state = incrementModuleEditVersion({
            state,
            id: nodeId
          });
        }
        const existingLayoutStyles = node.getLayoutStyleData() || {};
        const existingBreakpointStyles = existingLayoutStyles.breakpointStyles || {};

        // Create new object reference, copying refrences to all the existing styles set in that breakpoint
        const newStylesForThisBreakpoint = Object.assign({},
        // New object reference for this breakpoint
        existingBreakpointStyles[breakpoint],
        // Copy over references to all the existing styles objects
        newLayoutStyles // Override just the styles that changed
        );

        // Create new object reference, copying references to all the existing breakpoint objects
        const newBreakpointStyles = Object.assign({},
        // New object reference
        existingBreakpointStyles,
        // Copy over references to all the existing breakpoint objects
        {
          [breakpoint]: newStylesForThisBreakpoint // Override just the breakpoint we are modifying with the `newStylesForThisBreakpoint` object from above
        });
        let newTree;
        if (isCell) {
          newTree = tree.mergeIntoCellStyles(nodeId, {
            breakpointStyles: newBreakpointStyles
          }).tree;
        } else {
          newTree = tree.mergeIntoRowStyles(nodeId, {
            breakpointStyles: newBreakpointStyles
          }).tree;
        }
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.LAYOUT_SECTION_ROW_RESET_LAYOUT_STYLES:
      {
        const {
          layoutSectionId,
          rowId
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const newTree = tree.mergeIntoRowValue(rowId, {
          styles: {}
        }).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.MOBILE_LAYOUT_SECTION_ROW_RESET_LAYOUT_STYLES:
      {
        const {
          layoutSectionId,
          rowId
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const newTree = tree.mergeIntoRowValue(rowId, {
          mobileMargin: {},
          mobilePadding: {}
        }, {
          path: ['styles']
        }).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.LAYOUT_SECTION_ROW_SET_VERTICAL_ALIGNMENT:
      {
        const {
          layoutSectionId,
          rowId,
          verticalAlignment
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const newTree = setAlignmentOnAllColumnsInRow(tree, rowId, verticalAlignment).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.LAYOUT_SECTION_SET_CELL_CSS_ID:
      {
        const {
          layoutSectionId,
          cellId,
          cssId
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const newTree = tree.mergeIntoCellParams(cellId, {
          css_id: cssId
        }).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.LAYOUT_SECTION_SET_CELL_CSS_STYLES:
      {
        const {
          layoutSectionId,
          cellId,
          cssStyles
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const newTree = tree.mergeIntoCellParams(cellId, {
          css_style: cssStyles
        }).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.LAYOUT_SECTION_SET_CELL_CSS_CLASS:
      {
        const {
          layoutSectionId,
          cellId,
          cssClass
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const newClassString = cssClass;
        const newTree = tree.mergeIntoCellParams(cellId, {
          css_class: newClassString
        }).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.LAYOUT_SECTION_SET_ROW_CSS_CLASS:
      {
        const {
          layoutSectionId,
          rowId,
          cssClass
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const newClassString = cssClass;
        const newTree = tree.mergeIntoRowValue(rowId, {
          cssClass: newClassString
        }).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.LAYOUT_SECTION_ADD_CLASS_TO_CELL:
      {
        const {
          layoutSectionId,
          cellId,
          cssClass
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const currentParams = tree.findCell(cellId).getParams();
        const newClassString = `${currentParams.css_class} ${cssClass}`;
        const newTree = tree.mergeIntoCellParams(cellId, {
          css_class: newClassString
        }).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.LAYOUT_SECTION_REMOVE_CLASS_FROM_CELL:
      {
        const {
          layoutSectionId,
          cellId,
          cssClass
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const currentParams = tree.findCell(cellId).getParams();
        const classRegex = new RegExp(`(?:(\\s|^))${cssClass}(?:(\\s|$))`, 'g');
        const newClassString = currentParams.css_class.replace(classRegex, '');
        const newTree = tree.mergeIntoCellParams(cellId, {
          css_class: newClassString
        }).tree;
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.LAYOUT_SECTION_COLUMNS_RESIZED:
      {
        const {
          layoutSectionId,
          leftColumnInfo,
          rightColumnInfo
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        const newTree = modifyColumnWidths(tree, leftColumnInfo, rightColumnInfo);
        if (state.getIn(['layoutSectionTrees', layoutSectionId]) !== newTree) {
          state = state.setIn(['layoutSectionTrees', layoutSectionId], newTree);
        }
        return state;
      }
    case actionTypes.LAYOUT_SECTION_SET_LABEL:
      {
        const {
          id,
          partialBody,
          isRow
        } = payload;
        return mergeLayoutFragmentDataHelper(state, id, partialBody, isRow);
      }
    case actionTypes.GRID_LAYOUTS_SET_LABEL:
      {
        const {
          id,
          partialBody,
          gridLayoutId
        } = payload;
        return updateGridNodeLabelHelper(state, id, partialBody, gridLayoutId);
      }
    case actionTypes.SET_MODULE_BODY:
      {
        const {
          id,
          body
        } = payload;
        const tree = findTreeWithCellName(state, id);
        state = incrementModuleEditVersion({
          state,
          id
        });
        if (tree) {
          state = copyLayoutSectionFromSchemaToContentIfNeeded(state, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = state.getIn(['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(id);

          // CSS data from template is stored in the cell params, but with CMV1 templates
          // we compeltely replace the params of a cell with the new module body coming in.
          // This is special casing the css data to make sure it doesn't get blown away on the layout
          // tree cell when a module body is replaced.
          const existingCellParams = cell.getParams();
          const existingCellStyles = {
            css_id: existingCellParams.css_id,
            css_class: existingCellParams.css_class,
            css_style: existingCellParams.css_style
          };
          const newParamsToSet = Object.assign({}, existingCellStyles, body);
          ({
            tree: newTree
          } = newTree.modifyCellParams(cell.getName(), newParamsToSet));
          return state.setIn(['layoutSectionTrees', tree.getRootName()], newTree);
        }
        const keyBase = getKeyForNonLayoutSection(state, id);
        if (!keyBase) {
          logUnknownModuleToRaven(id);
          return state;
        }
        const key = [...keyBase, 'body'];
        return state.setIn(key, Immutable.fromJS(body));
      }
    case actionTypes.SET_DEPRECATED_STYLES_FLAGS:
    case actionTypes.MERGE_MODULE_BODY:
      {
        const {
          id,
          partialBody,
          moduleDefaultType,
          metaData
        } = payload;
        state = updateMetaDataForModule(state, id, metaData);
        state = incrementModuleEditVersion({
          state,
          id
        });
        return mergeModuleBodyHelper(state, id, partialBody, {
          moduleDefaultType
        });
      }
    case actionTypes.MERGE_GRID_MODULE_BODY:
      {
        const {
          id,
          partialBody,
          moduleDefaultType,
          metaData
        } = payload;
        state = updateMetaDataForModule(state, id, metaData);
        state = incrementModuleEditVersion({
          state,
          id
        });
        return mergeGridModuleBodyHelper(state, id, partialBody, {
          moduleDefaultType
        });
      }
    case actionTypes.MERGE_MODULE_DATA:
      {
        const {
          id,
          partialBody,
          metaData,
          layoutSectionId,
          gridLayoutId
        } = payload;
        state = updateMetaDataForModule(state, id, metaData);
        state = incrementModuleEditVersion({
          state,
          id
        });
        if (gridLayoutId && partialBody.label) {
          return updateGridNodeLabelHelper(state, id, partialBody, gridLayoutId, true);
        }
        return mergeModuleDataHelper(state, id, partialBody, layoutSectionId);
      }
    case actionTypes.MERGE_MODULE_META_DATA:
      {
        const {
          id,
          metaData,
          incrementEditVersion
        } = payload;
        const updatedState = updateMetaDataForModule(state, id, metaData);
        if (incrementEditVersion) {
          return incrementModuleEditVersion({
            state: updatedState,
            id
          });
        }
        return updatedState;
      }
    case actionTypes.SET_MODULE_SMART_OBJECT_BODY:
      {
        const {
          id,
          smartObjectIndex,
          body,
          updateEditVersion
        } = payload;
        const tree = findTreeWithCellName(state, id);
        if (updateEditVersion) {
          state = incrementModuleEditVersion({
            state,
            id
          });
        }
        if (tree) {
          state = copyLayoutSectionFromSchemaToContentIfNeeded(state, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = state.getIn(['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(id);
          const smartObjectsFromTree = cell.getParams().smart_objects;
          const immutableSmartObjects = Immutable.Iterable.isIterable(smartObjectsFromTree) ? smartObjectsFromTree : Immutable.fromJS(smartObjectsFromTree);
          const newParamPartial = {
            smart_objects: immutableSmartObjects.mergeIn([smartObjectIndex, 'body'], body).toJS()
          };
          ({
            tree: newTree
          } = newTree.mergeIntoCellParams(cell.getName(), newParamPartial));
          return state.setIn(['layoutSectionTrees', tree.getRootName()], newTree);
        }
        const keyBase = getKeyForNonLayoutSection(state, id);
        if (!keyBase) {
          logUnknownModuleToRaven(id);
          return state;
        }
        const key = [...keyBase, 'smart_objects', smartObjectIndex, 'body'];
        return state.setIn(key, Immutable.fromJS(body));
      }
    case actionTypes.MERGE_MODULE_SMART_OBJECT_BODY:
      {
        const {
          id,
          metaData,
          partialBody,
          smartObjectIndex,
          updateEditVersion
        } = payload;
        state = updateMetaDataForModule(state, id, metaData);
        const tree = findTreeWithCellName(state, id);
        if (updateEditVersion) {
          state = incrementModuleEditVersion({
            state,
            id
          });
        }
        if (tree) {
          state = copyLayoutSectionFromSchemaToContentIfNeeded(state, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = state.getIn(['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(id);
          const smartObjectsFromTree = cell.getParams().smart_objects;
          const immutableSmartObjects = Immutable.Iterable.isIterable(smartObjectsFromTree) ? smartObjectsFromTree : Immutable.fromJS(smartObjectsFromTree);
          const newParamPartial = {
            smart_objects: immutableSmartObjects.mergeIn([smartObjectIndex, 'body'], partialBody).toJS()
          };
          ({
            tree: newTree
          } = newTree.mergeIntoCellParams(cell.getName(), newParamPartial));
          return state.setIn(['layoutSectionTrees', tree.getRootName()], newTree);
        }
        const keyBase = getKeyForNonLayoutSection(state, id);
        if (!keyBase) {
          logUnknownModuleToRaven(id);
          return state;
        }
        const key = [...keyBase, 'smart_objects', smartObjectIndex, 'body'];
        return state.mergeIn(key, Immutable.fromJS(partialBody));
      }
    case actionTypes.SET_MODULE_STYLES:
      {
        const {
          id,
          styles
        } = payload;
        const tree = findTreeWithCellName(state, id);
        if (tree) {
          state = copyLayoutSectionFromSchemaToContentIfNeeded(state, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = state.getIn(['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(id);
          ({
            tree: newTree
          } = newTree.mergeIntoCellParams(cell.getName(), styles));
          return state.setIn(['layoutSectionTrees', tree.getRootName()], newTree);
        }
        let pathToKey;
        if (id === BODY_ID) {
          pathToKey = ['contentCss', BODY_ID];
        } else {
          const keyBase = getKeyForNonLayoutSection(state, id);
          if (!keyBase) {
            logUnknownModuleToRaven(id);
            return state;
          }
          pathToKey = [...keyBase, 'css'];
        }
        if (styles.css) {
          state = state.setIn(pathToKey, Immutable.fromJS(styles.css));
        }
        if (styles.child_css) {
          state = state.setIn([...getKeyForNonLayoutSection(state, id), 'child_css'], Immutable.fromJS(styles.child_css));
        }
        return state;
      }
    case actionTypes.SET_MODULE_BREAKPOINT_STYLES:
      {
        const {
          id,
          styles,
          activeBreakpoint
        } = payload;
        state = incrementModuleEditVersion({
          state,
          id
        });
        const keyBase = getKeyForNonLayoutSection(state, id);
        if (!keyBase) {
          logUnknownModuleToRaven(id);
          return state;
        }
        const stylePath = [...keyBase, 'styles'];
        const breakpointPath = [...stylePath, 'breakpointStyles', activeBreakpoint];
        const existingBreakpointStyles = state.getIn(breakpointPath,
        // @ts-ignore will be migrated
        new ImmutableMap());
        const newBreakpointStyles = existingBreakpointStyles.merge(Immutable.fromJS(styles));
        state = state.setIn(breakpointPath, newBreakpointStyles);
        return state;
      }
    case actionTypes.REMOVE_FAKE_BODY_MODULE_STYLES:
      {
        return state.removeIn(['contentCss', BODY_ID]);
      }
    case actionTypes.UPDATED_CONTAINERS_FROM_PREVIEW:
      {
        const {
          containers
        } = payload;
        // @ts-ignore will be migrated
        return containers.reduce((currentState, container) => {
          const {
            id,
            widgets
          } = container;
          // @ts-ignore will be migrated
          const modules = new Immutable.List(
          // @ts-ignore will be migrated
          widgets.map((moduleId, order) => {
            var _getKeyForNonLayoutSe2;
            return state.getIn((_getKeyForNonLayoutSe2 = getKeyForNonLayoutSection(state, moduleId)) !== null && _getKeyForNonLayoutSe2 !== void 0 ? _getKeyForNonLayoutSe2 : ['widgetContainers', undefined, 'widgets', undefined]).set('order', order);
          }));
          return currentState.setIn(['widgetContainers', id, 'widgets'], modules);
        }, state);
      }
    case actionTypes.UPDATED_MODULE_SMART_RULES:
      {
        const {
          id,
          smartObject: {
            body,
            definition_id,
            smart_type,
            smart_objects
          }
        } = payload;
        const tree = findTreeWithCellName(state, id);
        const contentsToMerge = {
          smart_objects
        };
        if (smart_objects.length && (!definition_id || !smart_type)) {
          captureMessage('Trying to update smart objects with null definition_id or null smart_type in non-deletion action', {
            level: 'warning',
            extra: payload
          });
        } else {
          // @ts-ignore will be migrated
          contentsToMerge.definition_id = definition_id;
          // @ts-ignore will be migrated
          contentsToMerge.smart_type = smart_type;
        }
        if (tree) {
          state = copyLayoutSectionFromSchemaToContentIfNeeded(state, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = state.getIn(['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(id);
          const paramsToMerge = body ? Object.assign({}, body, contentsToMerge) : contentsToMerge;
          ({
            tree: newTree
          } = newTree.mergeIntoCellParams(cell.getName(), paramsToMerge));
          return state.setIn(['layoutSectionTrees', tree.getRootName()], newTree);
        }
        const key = getKeyForNonLayoutSection(state, id);
        if (!key) {
          logUnknownModuleToRaven(id);
          return state;
        }
        if (body && body.size > 0) {
          state = state.setIn([...key, 'body'], Immutable.fromJS(body));
        }
        return state.mergeIn(key, contentsToMerge);
      }
    case actionTypes.REMOVED_MODULE_SMART_RULES:
      {
        const tree = findTreeWithCellName(state, payload.id);
        if (tree) {
          state = copyLayoutSectionFromSchemaToContentIfNeeded(state, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = state.getIn(['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(payload.id);
          const modifiedParams = cell.getParams();
          modifiedParams.definition_id = null;
          modifiedParams.smart_type = null;
          modifiedParams.smart_objects = [];
          ({
            tree: newTree
          } = newTree.modifyCellParams(cell.getName(), modifiedParams));
          return state.setIn(['layoutSectionTrees', tree.getRootName()], newTree);
        }
        const key = getKeyForNonLayoutSection(state, payload.id);
        if (!key) {
          logUnknownModuleToRaven(payload.id);
          return state;
        }

        // TODO: Task didn't handle chained set's well
        return state.setIn([...key, 'definition_id'], null).setIn([...key, 'smart_type'], null)
        // @ts-ignore will be migrated
        .setIn([...key, 'smart_objects'], new Immutable.List());
      }
    case actionTypes.RESYNCHRONIZE_MODULE_SMART_OBJECTS:
      {
        const {
          moduleId,
          smartObjects
        } = payload;
        const tree = findTreeWithCellName(state, moduleId);
        if (tree) {
          state = copyLayoutSectionFromSchemaToContentIfNeeded(state, tree.getRootName());
          // Make sure to get cell reference in newly modified tree
          let newTree = state.getIn(['layoutSectionTrees', tree.getRootName()]);
          const cell = tree.findCell(moduleId);
          ({
            tree: newTree
          } = newTree.mergeIntoCellParams(cell.getName(), {
            smart_objects: smartObjects
          }));
          return state.setIn(['layoutSectionTrees', tree.getRootName()], newTree);
        }
        const keyBase = getKeyForNonLayoutSection(state, moduleId);
        if (!keyBase) {
          logUnknownModuleToRaven(moduleId);
          return state;
        }
        const key = [...keyBase, 'smart_objects'];
        return state.setIn(key, smartObjects);
      }
    case actionTypes.CLONED_MODULES_QUEUE_CLEARED:
      {
        // Clear all nodes from pending width queue
        state = state.set('clonedModulesPendingDomOperations',
        // @ts-ignore will be migrated
        new Immutable.Set());
        return state;
      }
    case actionTypes.CLONED_STATIC_SECTION_MAP_CLEARED:
      {
        state = state.set('mapOfClonedToOldStaticSectionName',
        // @ts-ignore will be migrated
        new Immutable.Map());
        return state;
      }
    case actionTypes.ADDED_MODULES_TO_FAKE_MODULES:
      {
        const {
          modules
        } = payload;
        return state.set('fakeModules', state.get('fakeModules').merge(Immutable.fromJS(modules)));
      }
    case actionTypes.ADDED_CUSTOM_UPDATES_FOR_FAKE_MODULES:
      {
        const {
          customUpdates
        } = payload;
        return state.mergeIn(['fakeModuleCustomUpdates'], Immutable.fromJS(customUpdates));
      }
    case actionTypes.CUSTOM_LAYOUT_SECTION_ADDED:
      {
        const {
          layoutSectionId,
          rowIdToInsertAround,
          targetBeforeOrAfter,
          isEmptyLayoutSection,
          rowIdToMove,
          tempCustomSectionTree,
          customSectionModuleSchemas
        } = payload;
        const tree = getLayoutSectionTreeToModify(state, layoutSectionId);
        let newTree;
        let newOriginTree;
        let modifiedColumns;
        if (isEmptyLayoutSection) {
          ({
            tree: newTree,
            originTree: newOriginTree,
            modifiedColumns
          } = appendRowToCell(tree, layoutSectionId, {
            existingRowId: rowIdToMove,
            customSectionModuleSchemas,
            originTree: tempCustomSectionTree
          }));
        } else {
          const insertMethod = targetBeforeOrAfter === BEFORE ? insertRowBefore : insertRowAfter;
          ({
            tree: newTree,
            originTree: newOriginTree,
            modifiedColumns
          } = insertMethod(tree, rowIdToInsertAround, {
            existingRowId: rowIdToMove,
            originTree: tempCustomSectionTree
          }));
        }
        return updateLayoutSectionTreeAndWidgets({
          layoutSectionId,
          customSectionModuleSchemas,
          modifiedColumns,
          tree: newTree,
          originTree: newOriginTree,
          state
        });
      }
    case actionTypes.UPDATE_STATIC_MODULE_WITH_NEW_ID:
      {
        const {
          id,
          newModule
        } = payload;
        state = state.setIn(['widgets', newModule.get('name')], newModule);
        state = state.setIn(['schemaWidgets', newModule.get('name')], newModule);
        state = state.deleteIn(['schemaWidgets', id]);
        state = state.deleteIn(['widgets', id]);
        return state;
      }
    case actionTypes.RESET_LAYOUT_SECTION_TO_TEMPLATE_DEFAULT:
      {
        const {
          id
        } = payload;
        state = copyLayoutSectionFromSchemaToContent(state, id, state.get('layoutSectionWidgets'));
        return state;
      }
    case actionTypes.ADD_NEW_EMBED_TO_EMBED_INFO:
      {
        const {
          id,
          embedInfo
        } = payload;
        const idAsString = `${id}`;
        if (!state.hasIn(['embedInfo', idAsString])) {
          state = state.setIn(['embedInfo', idAsString], Immutable.fromJS(embedInfo));
        }
        return state;
      }
    case actionTypes.GRID_LAYOUTS_ELEMENT_INSERTED_BEFORE:
      {
        const {
          containerId,
          targetedElementId,
          gridLayoutId,
          existingNodeId,
          content,
          newModuleSchemaJson
        } = action.payload;
        let newTree = getGridLayoutTreeToModify(state, gridLayoutId);
        if (existingNodeId) {
          ({
            tree: newTree
          } = newTree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: containerId,
            beforeNodeId: targetedElementId
          }));
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          newTree = newTree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId,
            beforeNodeId: targetedElementId
          });
        }
        state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        return state;
      }
    case actionTypes.GRID_LAYOUTS_ELEMENT_INSERTED_AFTER:
      {
        const {
          containerId,
          targetedElementId,
          gridLayoutId,
          existingNodeId,
          newModuleSchemaJson,
          content
        } = action.payload;
        let newTree = getGridLayoutTreeToModify(state, gridLayoutId);
        if (existingNodeId) {
          ({
            tree: newTree
          } = newTree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: containerId,
            afterNodeId: targetedElementId
          }));
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          newTree = newTree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId,
            afterNodeId: targetedElementId
          });
        }
        state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        return state;
      }
    case actionTypes.GRID_LAYOUTS_INSERT_BLANK_SECTION:
      {
        const uncastedPayload = action.payload;
        const {
          gridLayoutId,
          beforeNodeId,
          afterNodeId,
          newSectionLayout
        } = uncastedPayload;
        const tree = getGridLayoutTreeToModify(state, gridLayoutId);
        const {
            child: newContainer
          } = newSectionLayout,
          newSection = _objectWithoutPropertiesLoose(newSectionLayout, _excluded2);
        const {
          tree: newTreeToInsertChild,
          node: newSectionNode
        } = tree.insertNewNode({
          newNodeValue: newSection,
          parentNodeId: tree.getRootId(),
          beforeNodeId,
          afterNodeId
        });
        const {
          tree: newTreeToInsertChildren,
          node: newContainerNode
        } = newTreeToInsertChild.insertNewNode({
          newNodeValue: newContainer,
          parentNodeId: newSectionNode.getId(),
          beforeNodeId,
          afterNodeId
        });
        let finalTree = newTreeToInsertChildren;
        if (isContainer(newContainer)) {
          newContainer.children.forEach(child => {
            const {
              tree: newTree
            } = finalTree.insertNewNode({
              newNodeValue: child,
              parentNodeId: newContainerNode.getId(),
              beforeNodeId,
              afterNodeId
            });
            finalTree = newTree;
          });
        }
        state = state.setIn(['gridLayoutTrees', gridLayoutId], finalTree);
        return state;
      }
    case actionTypes.GRID_LAYOUTS_MOVE_SECTION_BEFORE:
      {
        const {
          gridLayoutId,
          existingNodeId,
          parentId,
          targetedSectionId
        } = action.payload;
        const tree = getGridLayoutTreeToModify(state, gridLayoutId);
        if (existingNodeId) {
          const {
            tree: newTree
          } = tree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: parentId,
            beforeNodeId: targetedSectionId
          });
          state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        }
        return state;
      }
    case actionTypes.GRID_LAYOUTS_MOVE_SECTION_AFTER:
      {
        const {
          gridLayoutId,
          existingNodeId,
          parentId,
          targetedSectionId
        } = action.payload;
        const tree = getGridLayoutTreeToModify(state, gridLayoutId);
        if (existingNodeId) {
          const {
            tree: newTree
          } = tree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: parentId,
            afterNodeId: targetedSectionId
          });
          state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        }
        return state;
      }
    case actionTypes.GRID_LAYOUTS_INSERTED_IN_EMPTY_STACK:
      {
        const {
          containerId,
          gridLayoutId,
          existingNodeId,
          newModuleSchemaJson,
          content
        } = action.payload;
        let newTree = getGridLayoutTreeToModify(state, gridLayoutId);
        if (existingNodeId) {
          ({
            tree: newTree
          } = newTree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: containerId
          }));
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          newTree = newTree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId
          });
        }
        state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        return state;
      }
    case actionTypes.GRID_LAYOUTS_INSERTED_IN_EMPTY_GRID_LAYOUT:
      {
        const {
          gridLayoutId,
          newModuleSchemaJson,
          content
        } = action.payload;
        let newTree = getGridLayoutTreeToModify(state, gridLayoutId);
        if (content || newModuleSchemaJson) {
          let newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          if (newGridContent.type === GRID_NODE_TYPES.MODULE) {
            const containerWrapper = {
              __typename: ContainerTypename,
              type: GRID_NODE_TYPES.CONTAINER,
              id: generateUniqueId('container-'),
              children: [newGridContent],
              layout: {
                layout: {
                  default: {
                    __typename: StackContainerLayoutTypename,
                    type: 'STACK',
                    direction: 'HORIZONTAL'
                  }
                }
              },
              styles: {
                breakpointStyles: {
                  default: {
                    backgroundLayers: []
                  }
                }
              }
            };
            newGridContent = {
              type: GRID_NODE_TYPES.SECTION,
              id: generateUniqueId('section-'),
              styles: {
                breakpointStyles: {}
              },
              child: containerWrapper
            };
          } else if (newGridContent.type === GRID_NODE_TYPES.CONTAINER) {
            newGridContent = {
              type: GRID_NODE_TYPES.SECTION,
              id: generateUniqueId('section-'),
              styles: {
                breakpointStyles: {}
              },
              child: newGridContent
            };
          }
          newTree = newTree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: gridLayoutId
          });
        }
        state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        return state;
      }
    case actionTypes.GRID_LAYOUTS_ELEMENT_APPENDED:
      {
        const {
          containerId,
          lastChildId,
          gridLayoutId,
          existingNodeId,
          content,
          newModuleSchemaJson
        } = action.payload;
        let newTree = getGridLayoutTreeToModify(state, gridLayoutId);
        if (existingNodeId) {
          ({
            tree: newTree
          } = newTree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: containerId,
            afterNodeId: lastChildId
          }));
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          newTree = newTree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId
          });
        }
        state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        return state;
      }
    case actionTypes.GRID_LAYOUTS_ELEMENT_PREPENDED:
      {
        const {
          containerId,
          firstChildId,
          gridLayoutId,
          existingNodeId,
          content,
          newModuleSchemaJson
        } = action.payload;
        let newTree = getGridLayoutTreeToModify(state, gridLayoutId);
        if (existingNodeId) {
          ({
            tree: newTree
          } = newTree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: containerId,
            beforeNodeId: firstChildId
          }));
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          newTree = newTree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId,
            beforeNodeId: firstChildId
          });
        }
        state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        return state;
      }
    case actionTypes.GRID_LAYOUTS_INSERTED_IN_TABLE_CELL:
      {
        const {
          containerId,
          targetedCellId,
          gridLayoutId,
          content,
          existingNodeId,
          newModuleSchemaJson
        } = action.payload;
        const tree = getGridLayoutTreeToModify(state, gridLayoutId);
        if (existingNodeId) {
          const existingNode = tree.findNode(existingNodeId);
          if (
          // If the existing node is being rearranged within the containing grid
          existingNode.getParentNodeId() === containerId && existingNode.isGridContainerCell()) {
            const parentNode = existingNode.getParentNode();
            const indexOfExistingNode = parentNode.indexOfChildNode(existingNodeId);
            const indexOfTargetedCell = parentNode.indexOfChildNode(targetedCellId);

            // If the existing node is being moved forward in the grid, we want
            // to swap the positions of the existing node and the targeted cell
            if (indexOfTargetedCell > indexOfExistingNode) {
              if (indexOfTargetedCell - indexOfExistingNode === 1) {
                // Since the node is immediately next to the targeted cell,
                // place it after the targeted cell
                const {
                  tree: newTree
                } = tree.moveNode({
                  nodeId: existingNodeId,
                  destParentNodeId: containerId,
                  afterNodeId: targetedCellId
                });
                state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
              } else {
                // If the node is not next to the targeted cell, we need to
                // move the node after the targeted cell and then move the
                // targeted cell to the position of the existing node
                const nodeIdAfterExistingNode = parentNode.getChildNodeIds()[indexOfExistingNode + 1];
                const {
                  tree: tempTreeToSwapTargetedCell
                } = tree.moveNode({
                  nodeId: existingNodeId,
                  destParentNodeId: containerId,
                  afterNodeId: targetedCellId
                });
                const {
                  tree: newTree2
                } = tempTreeToSwapTargetedCell.moveNode({
                  nodeId: targetedCellId,
                  destParentNodeId: containerId,
                  beforeNodeId: nodeIdAfterExistingNode
                });
                state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree2);
              }
            } else {
              // If the existing node is being moved backward in the grid, we
              // instead put the existing node behind the targeted cell
              const {
                tree: newTree
              } = tree.moveNode({
                nodeId: existingNodeId,
                destParentNodeId: containerId,
                beforeNodeId: targetedCellId
              });
              state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
            }
          } else {
            // Else, the node is coming from outside the grid
            const {
              tree: newTree
            } = tree.moveNode({
              nodeId: existingNodeId,
              destParentNodeId: containerId,
              afterNodeId: targetedCellId
            });
            state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
          }
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          const newTree = tree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId,
            afterNodeId: targetedCellId
          });
          state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        }
        return state;
      }
    case actionTypes.GRID_LAYOUTS_APPENDED_GRID_CELL:
      {
        const {
          containerId,
          lastChildId,
          gridLayoutId,
          existingNodeId,
          content,
          newModuleSchemaJson
        } = action.payload;
        const tree = getGridLayoutTreeToModify(state, gridLayoutId);
        if (existingNodeId) {
          const {
            tree: newTree
          } = tree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: containerId,
            afterNodeId: lastChildId
          });
          state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          const newTree = tree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId,
            afterNodeId: lastChildId
          });
          state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        }
        return state;
      }
    case actionTypes.GRID_LAYOUTS_INSERTED_AFTER_TABLE_CELL:
      {
        const {
          containerId,
          nextSiblingId,
          gridLayoutId,
          existingNodeId,
          content,
          newModuleSchemaJson
        } = action.payload;
        const tree = getGridLayoutTreeToModify(state, gridLayoutId);
        if (existingNodeId) {
          const {
            tree: newTree
          } = tree.moveNode({
            nodeId: existingNodeId,
            destParentNodeId: containerId,
            beforeNodeId: nextSiblingId
          });
          state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          const newTree = tree.insertSubtree({
            subtree: newGridContent,
            parentNodeId: containerId,
            beforeNodeId: nextSiblingId
          });
          state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        }
        return state;
      }

    // TODO: Implement moduleReducer logic for wrap and insert drop targets.
    case actionTypes.GRID_LAYOUTS_WRAP_AND_INSERT_ABOVE_CONTAINER:
    case actionTypes.GRID_LAYOUTS_WRAP_AND_INSERT_BELOW_CONTAINER:
      {
        const {
          gridLayoutId,
          existingNodeId,
          containerId,
          parentId,
          content,
          newModuleSchemaJson
        } = action.payload;
        let newTree = getGridLayoutTreeToModify(state, gridLayoutId);
        const newNodePositionParams = action.type === actionTypes.GRID_LAYOUTS_WRAP_AND_INSERT_ABOVE_CONTAINER ? {
          beforeNodeId: containerId
        } : {
          afterNodeId: containerId
        };
        const newContainer = createGridContainer(BUILDING_BLOCK_TYPES.VERTICAL_STACK);
        ({
          tree: newTree
        } = newTree.wrapSectionContainer({
          sectionId: parentId,
          newSectionContainerNodeValue: newContainer
        }));
        if (existingNodeId) {
          ({
            tree: newTree
          } = newTree.moveNode(Object.assign({
            nodeId: existingNodeId,
            destParentNodeId: newContainer.id
          }, newNodePositionParams)));
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          ({
            tree: newTree
          } = newTree.insertNewNode(Object.assign({
            newNodeValue: newGridContent,
            parentNodeId: newContainer.id
          }, newNodePositionParams)));
        }
        state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        return state;
      }
    case actionTypes.GRID_LAYOUTS_WRAP_AND_INSERT_LEFT_OF_CONTAINER:
    case actionTypes.GRID_LAYOUTS_WRAP_AND_INSERT_RIGHT_OF_CONTAINER:
      {
        const {
          gridLayoutId,
          existingNodeId,
          containerId,
          parentId,
          content,
          newModuleSchemaJson
        } = action.payload;
        let newTree = getGridLayoutTreeToModify(state, gridLayoutId);
        const newNodePositionParams = action.type === actionTypes.GRID_LAYOUTS_WRAP_AND_INSERT_LEFT_OF_CONTAINER ? {
          beforeNodeId: containerId
        } : {
          afterNodeId: containerId
        };
        const newContainer = createGridContainer(BUILDING_BLOCK_TYPES.HORIZONTAL_STACK);
        ({
          tree: newTree
        } = newTree.wrapSectionContainer({
          sectionId: parentId,
          newSectionContainerNodeValue: newContainer
        }));
        if (existingNodeId) {
          ({
            tree: newTree
          } = newTree.moveNode(Object.assign({
            nodeId: existingNodeId,
            destParentNodeId: newContainer.id
          }, newNodePositionParams)));
        } else if (content || newModuleSchemaJson) {
          const newGridContent = content || prepareNewGridModuleDataHelper(newModuleSchemaJson);
          ({
            tree: newTree
          } = newTree.insertNewNode(Object.assign({
            newNodeValue: newGridContent,
            parentNodeId: newContainer.id
          }, newNodePositionParams)));
        }
        state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        return state;
      }
    case actionTypes.GRID_LAYOUTS_NODE_CLONED_AND_INSERTED_AFTER_ORIGINAL:
      {
        const uncastedPayload = action.payload;
        const {
          gridLayoutId,
          nodeId
        } = uncastedPayload;
        const tree = getGridLayoutTreeToModify(state, gridLayoutId);
        const node = tree.findNode(nodeId);
        // If the node is a container and a child of a section, we need to clone
        // the parent section instead, since sections must have exactly one child
        if (node.isContainer() && node.isChildOfSection()) {
          const {
            tree: newTree,
            node: clonedNode,
            clonedIdToOriginalIdMap
          } = tree.cloneNode({
            nodeId: node.getParentNodeId()
          });
          state = copyClonedModulesToGridLayoutModules(state, clonedNode, clonedIdToOriginalIdMap);
          state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        } else {
          const {
            tree: newTree,
            node: clonedNode,
            clonedIdToOriginalIdMap
          } = tree.cloneNode({
            nodeId
          });
          state = copyClonedModulesToGridLayoutModules(state, clonedNode, clonedIdToOriginalIdMap);
          state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        }
        return state;
      }
    case actionTypes.GRID_LAYOUTS_SECTION_DELETED:
    case actionTypes.GRID_LAYOUTS_CONTAINER_DELETED:
    case actionTypes.GRID_LAYOUTS_MODULE_DELETED:
      {
        const uncastedPayload = action.payload;
        const {
          gridLayoutId,
          nodeId
        } = uncastedPayload;
        const tree = getGridLayoutTreeToModify(state, gridLayoutId);
        const {
          tree: newTree
        } = tree.removeNode(nodeId);
        state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        return state;
      }
    case actionTypes.GRID_SET_OLD_MODULE_STYLES:
      {
        const uncastedPayload = action.payload;
        const {
          nodeId,
          gridLayoutId,
          styles
        } = uncastedPayload;
        const currentTree = getGridLayoutTreeToModify(state, gridLayoutId);
        const convertedCss = styles !== null && styles !== void 0 && styles.css ? Object.entries(styles.css).reduce((acc, [key, value]) => {
          acc[key] = convertJsonToFieldValueAvroWithoutTypename(value);
          return acc;
        }, {}) : {};
        const convertedChildCss = styles !== null && styles !== void 0 && styles.child_css ? Object.entries(styles.child_css).reduce((acc, [key, value]) => {
          acc[key] = convertJsonToFieldValueAvroWithoutTypename(value);
          return acc;
        }, {}) : {};
        const oldModuleStyles = {
          css: convertedCss,
          childCss: convertedChildCss
        };
        const {
          tree
        } = currentTree.mergeModuleStyles(nodeId, {
          styleType: 'oldModuleStyles'
        }, oldModuleStyles);
        state = state.setIn(['gridLayoutTrees', gridLayoutId], tree);
        return state;
      }
    case actionTypes.GRID_LAYOUTS_SET_NODE_STYLES:
      {
        const uncastedPayload = action.payload;
        const {
          nodeId,
          gridLayoutId,
          styles,
          isEditorProvidedModuleStyles,
          activeBreakpoint
        } = uncastedPayload;
        const currentTree = getGridLayoutTreeToModify(state, gridLayoutId);
        if (isEditorProvidedModuleStyles) {
          const {
            tree
          } = currentTree.mergeModuleStyles(nodeId, {
            styleType: 'editorProvidedModuleBreakpointStyles',
            breakpointName: activeBreakpoint
          }, styles);
          state = state.setIn(['gridLayoutTrees', gridLayoutId], tree);
        } else {
          const node = currentTree.findNode(nodeId);
          if (node.isContainer()) {
            const {
              tree
            } = currentTree.mergeContainerStyles(nodeId, activeBreakpoint, styles);
            state = state.setIn(['gridLayoutTrees', gridLayoutId], tree);
          } else if (node.isSection()) {
            const {
              tree
            } = currentTree.mergeSectionStyles(nodeId, activeBreakpoint, styles);
            state = state.setIn(['gridLayoutTrees', gridLayoutId], tree);
          }
        }
        return state;
      }
    case actionTypes.GRID_LAYOUTS_UPDATE_NODE_LAYOUT:
      {
        const uncastedPayload = action.payload;
        const {
          nodeId,
          gridLayoutId,
          activeBreakpoint,
          layoutType
        } = uncastedPayload;
        const tree = getGridLayoutTreeToModify(state, gridLayoutId);
        const selectedNode = tree.findNode(nodeId);
        if (!selectedNode.isContainer()) {
          return state;
        }
        const selectedNodeLayout = getContainerBreakpointLayout(selectedNode, activeBreakpoint);
        let newContainerLayout = selectedNodeLayout;
        if (layoutType === 'GRID') {
          if (isStackContainerLayout(selectedNodeLayout)) {
            const {
              rows,
              columns
            } = convertStackToGridLayout(selectedNode.getChildNodes().length, selectedNodeLayout.direction);
            newContainerLayout = {
              __typename: GridContainerLayoutTypename,
              type: 'GRID',
              rows,
              columns
            };
          }
        } else {
          newContainerLayout = {
            __typename: StackContainerLayoutTypename,
            type: 'STACK',
            direction: layoutType
          };
        }
        const {
          tree: newTree
        } = tree.mergeContainerLayout(nodeId, activeBreakpoint, newContainerLayout);
        state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        return state;
      }
    case actionTypes.GRID_LAYOUTS_UPDATE_TABLE_DEFINITION:
      {
        const uncastedPayload = action.payload;
        const {
          nodeId,
          gridLayoutId,
          activeBreakpoint,
          newRows,
          newColumns
        } = uncastedPayload;
        const tree = getGridLayoutTreeToModify(state, gridLayoutId);
        const {
          tree: newTree
        } = tree.mergeContainerLayout(nodeId, activeBreakpoint, {
          __typename: GridContainerLayoutTypename,
          type: 'GRID',
          rows: newRows,
          columns: newColumns
        });
        state = state.setIn(['gridLayoutTrees', gridLayoutId], newTree);
        return state;
      }
    default:
      return state;
  }
};
export default moduleReducer;